import React, { useEffect, useState } from "react";
import regbanner from "../../../assets/icons/panDob.svg";
import InputField from "../../UI/InputField/InputField";
import Button from "../../UI/Button/Button";
import {
  authenticateNavBarObj,
  containerUrl,
  dashboardUrl,
  dematNavBarObj,
  DIY,
  leftNavBarArray,
  statusUrl,
} from "../../utils/constants";

import { pan, alphaNumExp } from "../../utils/regex";
import "./PANInfo.scss";
import {
  ACheckPanIbeats,
  AGetClientDetailsByPan,
  AGetClientDetailsByLeadId,
  AIsPANExists,
  ASavePanDobDetails,
  AGetCkycNumber,
  AGetKraDetails,
  AGetEmployeeByPan,
  ACheckUCCExists,
  APanVerification,
  ACheckKraPan,
} from "../../Services/registration/panDobApiService";
import {
  ACreateLeadSource,
  ALeadFetchApi,
} from "../../Services/registration/registrationApiService";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
import GlobalStore from "../../store/globalStore";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  clientContinue,
  utmDurationInfoObj,
  updateUtmInfo,
  setStageData,
  ageCalculator,
} from "../../Services/globalService";
import { APendingUploadList } from "../../Services/dashboard/eSignApiServices";
import {
  AGetCacheData,
  AGetStageCompletionStatus,
} from "../../Services/registration/continueApiService";
import { checkModuleCompleteness } from "../../Profile/ProfileNavBar/ProfileNavBar";
import Backdrop from "../../UI/Backdrop/Backdrop";
import Calender from "../../UI/Calender/Calender";
import moment from "moment";
import gtmService from "../../Services/gtmService";
import cleverTapEvents from "../../../config/cleverTapEvents";
import useQuery from "../../../customHooks/useQuery";
import { ClevertapService } from "../../Services/clevertapService";
import DocumentBrowse, {
  DocDetailFormat,
} from "../../UI/DocumentBrowse/DocumentBrowse";
import { initialPanDocObj } from "../../DocumentVerification/DocVerificationForm/DocVerificationForm";
import {
  AextractPanNew,
  ASaveDocumentDetails,
  QCServiceTaskCreation,
} from "../../Services/dashboard/docVerificationAPIServices";
import { AUploadDocument } from "../../Services/dashboard/brokerageServices";
import { AppsFlyerService } from "../../Services/appsFlyerService";
import appsFlyerEvents from "../../../config/appsFlyerEvents";
import Checkbox from "../../UI/Checkbox/Checkbox";
import config from "../../../config/domain";
import { errorMessage } from "../../utils/errorMessage";
import { ASendSms } from "../../Services/dashboard/ipvApiServices";
import { errorCode, errorMsg } from "../../../ErrorCode/ErrorCode";
import Loader from "../../UI/Loader/Loader";
import { getProfileDetailsFromAadhar } from "../ShareAdd/ShareAdd";
import DropdownSearch from "../../UI/DropdownSearch/DropdownSearch";
import PANInfoJoint from "./PANInfoJoint";
import PANInfoMinor from "./PanInfoMinor";
import PANInfoNonIndividual from "./PanInfoNonIndividual";
import { SUBTYPE_MAP } from "./PANInfoJoint.utils";

export interface IPanDobFields {
  pan: string;
  dob: Date | null;
  aadharLinked: "No" | "Yes" | "Not Sure";
  aadhaarNo?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  fatherName?: string;
  gurdianPanNo?: any;
  gurdianDOB?: Date | null;
  gurdianFName?: string;
  gurdianMName?: string;
  gurdianLName?: string;
  fullname?: any;
  minorPan?: string;
  relationshipId?: string;
}

const panValidationKeyList: any = {
  PanStatus: "PanStatusMsg",
  Name: "NameMsg",
  Dob: "DobMsg",
  SeedingStatus: "SeedingStatusMsg",
};

export interface iGeoLocation {
  loaded: boolean;
  coordinates: { lat: string; lng: string };
  error: boolean;
}

export type saveDocumentObj = {
  documentCategoryId?: string;
  documentId?: string;
  fileName: string;
  isfilecropped: boolean;
  mimeType: string | undefined;
  panno: string;
  personaldetailsid: string;
  autoqc: boolean;
  iskycdocument: boolean;
  documentNumber?: string;
};

export interface ILocalQueryObject {
  email?: string;
  mobile?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  pan?: string;
  dob?: string;
  productid?: string;
  categoryid?: string;
  rmid?: string;
  leadid?: string;
  accountCategory?: string;
  createdBy?: any;
  entityType?: any;
  clienttype?: any;
  entitySubType?: any;
  is_guradian_pan?: any;
  isguradianpan?: boolean;
  fullname?: any;
  applicationId?: any;
  categoryName?: any;
}

export interface PANInfoProps { }
let isPanLinkedToAadhar: boolean;

const PANInfo: React.FC<PANInfoProps> = (props) => {
  let panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/
  // Fetch query params for clervertap
  const quryParams = useQuery();
  const UTM_SOURCE = quryParams.get("utm_source")
    ? quryParams.get("utm_source")
    : "";
  const UTM_MEDIUM = quryParams.get("utm_medium")
    ? quryParams.get("utm_medium")
    : "";
  const UTM_CAMPAIGN = quryParams.get("utm_campaign")
    ? quryParams.get("utm_campaign")
    : "";
  let localURL = localStorage.getItem("currentURL"),
    navigateURL: string = "";
  const localProductCode = quryParams.get("productCode");
  const localProuctObj = quryParams.get("localProuctObj");
  const id = quryParams.get("id");
  const name = quryParams.get("name");
  const skipUrl = quryParams.get("skipUrl");
  const fromCibil = quryParams.get("fromCibil");
  const empCode = quryParams.get('empCode');

  const [dematAccountFound, setDematAccountFound] = React.useState<any>(null);
  if (
    localURL !== null &&
    localURL !== undefined &&
    localURL !== "" &&
    localURL?.length > 0
  ) {
    navigateURL = window.atob(localURL);
    localURL = window.atob(localURL);
  }
  const [prodObj, setProdObj] = React.useState<ILocalQueryObject>({});
  const [values, setValues] = React.useState<IPanDobFields>({
    pan: "",
    aadharLinked: "No",
    dob: null,
    //aadhaarNo: "",
    firstName: "",
    middleName: "",
    lastName: "",
    fatherName: "",
    minorPan: "",
    relationshipId: "",
  });
  const [validPan, setValidPan] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [errCode, setErrCode] = React.useState<any>("");
  const [startTime, setStartTime] = React.useState<Date>(new Date());
  let isEmployee: boolean = false;
  const [errors, setErrors] = React.useState<{
    [key in keyof IPanDobFields]?: string;
  }>({
    pan: undefined,
    dob: undefined,
    aadharLinked: undefined,
    aadhaarNo: undefined,
    firstName: undefined,
    middleName: undefined,
    lastName: undefined,
  });
  // const history = useHistory();
  const navigate = useNavigate()
  const [removePanImg, setRemovePanImg] = React.useState<boolean>(false);
  const [utmObj, setUtmObj] = React.useState<any>(null);
  const [panObj, setPanObj] = React.useState<DocDetailFormat>({
    ...initialPanDocObj,
  });

  const [consent, setConsent] = React.useState<boolean>(true);
  const [togPhoto, setTogPhoto] = React.useState<boolean>(false);
  const [panNumberMatched, setPanNumberMatched] = React.useState(false);
  const [dobChecked, setDobChecked] = React.useState(false);
  const [isNormalClient, setIsNormalClient] = React.useState<boolean>(false);
  const [panDobState, setPanDobState] = React.useState("");
  const [skipUrlBoolean, setSkipUrlBoolean] = React.useState<boolean>(false);
  const [errorFoundInPanValidation, setErrorFoundInPanValidation] =
    useState<boolean>(false);
  const [cacheResponse, setCacheResponse] = React.useState<any>(null);
  //setModalDisplayText

  const [panUploadObject, setPanUploadObject] = React.useState<any>("");
  const [panUploaded, setPanUploaded] = React.useState<boolean>(false);

  const [liveLocationCheck, setLiveLocationCheck] = useState<any>({
    checkPhotoLiveness: false,
    checkLocation: false,
  });
  const [stageBooleanFlags, setStageBooleanFlags] = React.useState<{
    isPersonalStage: boolean;
    isProfileStage: boolean;
  }>({
    isPersonalStage: false,
    isProfileStage: false,
  });
  const [photoErrorMsg, setPhotoErrorMsg] = React.useState("");
  const [seedingPopup, setSeedingPopup] = React.useState<boolean>(false);
  const [checkpanaaddharflag, setCheckpanaaddharflag] = React.useState<boolean>(
    GlobalStore.stageStatus.checkpanaaddharflag === false ? true : false
  );
  const [panOCR, setPanOCR] = useState<any>(null);
  const [willDoLater, setWillDoLater] = useState<boolean>(false);
  const [panFileUploaded, setPanFileUploaded] = useState<boolean>(false);
  const [panFileUploadedLoader, setPanFileUploadedLoader] =
    useState<boolean>(false);
  const [invalidPanFieldUploadedMsg, setInvalidPanFileUploadedMsg] =
    React.useState<string>("");
  const [applicationModeType, setApplicationModeType] = useState<any>("");
  const [cibilEmailFound, setCibilEmailFound] = React.useState<boolean>(false);
  const [modalDisplayText, setModalDisplayText] = useState<any>("");
  const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false);
  const [panInvalidMsg, setPanInvalidMsg] = React.useState<string>("");
  //  const [panValidationResp,setPanValidationResp]=React.useState<any>();
  let panValidationResp: any;
  const [applicationInitializedFlag, setApplicationInitializedFlag] =
    useState<boolean>(false);
  const [submitFlag, setSubmitFlag] = useState<boolean>(false);
  const [extractPanResponse, setExtractPanResponse] = React.useState<{
    age: number;
    date_of_birth: string;
    date_of_issue: string;
    fathers_name: string;
    id_number: string;
    is_scanned: boolean;
    minor: boolean;
    name_on_card: string;
    pan_type: string;
  }>();
  let salesLandingPage = localStorage.getItem("salesLandingPage");
  const [documentsInfo, setDocumentInfo] = useState({
    totalDocs: [],
    totalDocsCount: 0,
    uploadedDocsCount: 0,
  });

  const [entityType, setEntityType] = useState("")
  const [entitySubType, setEntitySubType] = useState("")

  let panDob: string;
  const saveDetails: saveDocumentObj[] = [];
  const saveKraDetails: saveDocumentObj[] = [];

  let kraDocCount = 0;
  let kraDocs = 0;
  // let totalDocs: Array<string> = [];
  // let totalDocsCount = 0;
  // let uploadedDocsCount = 0;
  const objUtm = JSON.parse(
    window.sessionStorage.getItem("objUTM_Info") || "{}"
  );
  let isPanLinkedToAadhar: boolean;
  const objAccType =
    window.sessionStorage.getItem("objAccType") || ""
  const checkAutoQcForPan = () => {
    let name =
      (values.firstName as string) + values.middleName + values.lastName;

    if (
      values.pan === extractPanResponse?.id_number &&
      moment(values.dob).format("YYYY-MM-DD") ===
      extractPanResponse?.date_of_birth &&
      name === extractPanResponse?.name_on_card.replace(/\s/g, "")
    ) {
      return true;
    } else {
      return false;
    }
  };
  const convertDate = (dateString: string, hypenFound?: boolean) => {
    // Split the input date string by "/"
    if (hypenFound) {
      const [year, month, day] = dateString.split("-");

      // Create a new Date object with the parsed values
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)); // month - 1 because months are zero-indexed

      // Format the date to "mm-dd-yyyy"
      const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, "0")}-${day.padStart(2, "0")}-${year}`;
      return formattedDate;
    } else {
      const [day, month, year] = dateString.split("/");

      // Create a new Date object with the parsed values
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)); // month - 1 because months are zero-indexed

      // Format the date to "mm-dd-yyyy"
      const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, "0")}-${day.padStart(2, "0")}-${year}`;
      return formattedDate;
    }
  };

  React.useEffect(() => {
    setEntityType(GlobalStore.entityType)
    setEntitySubType(GlobalStore.entitySubType)
    if (empCode !== null && empCode !== undefined && empCode !== "") {
      window.sessionStorage.setItem('empCode', empCode)
    }
    // Assign utm object into local state
    const objUtm = JSON.parse(
      window.sessionStorage.getItem("objUTM_Info") || "{}"
    );
    setUtmObj(objUtm);

    if (
      containerUrl.continue === clientContinue() &&
      !GlobalStore.isPartialFilledClient
    ) {
      console.log("showSubmitModal2", showSubmitModal);
      // history.push(containerUrl.continue);
      navigate(containerUrl.continue)
    } else {
      console.log("GlobalStore.leadId check =", GlobalStore.leadId);
      if (!GlobalStore.leadId || GlobalStore.leadId === "") {
        console.log("registration push");
        // history.push(containerUrl.registration);
      } else {
        init();
        window.scroll(0, 0);
      }
    }
    console.log("skipUrl", skipUrl);
    if (
      skipUrl !== null &&
      skipUrl !== undefined &&
      skipUrl !== "" &&
      skipUrl?.toLowerCase() == "yes"
    ) {
      localStorage?.removeItem("clientPartialDetails_ao");
      if (
        id !== null &&
        id !== undefined &&
        id !== "" &&
        id?.length > 0 &&
        name !== null &&
        name !== undefined &&
        name !== "" &&
        name?.length > 0
      ) {
        // setIsLoading(true);
        setPanFileUploadedLoader(true);
        ALeadFetchApi(
          (res: any) => {
            if (!res || res.error) {
              // setErrCode(164)
              setErrCode(errCode + res.error);
              setSkipUrlBoolean(true);
              setPanFileUploadedLoader(false);
              setCibilEmailFound(false);
              setPanFileUploaded(true);
              // gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124" });
            } else if (res?.data) {
              if (Array?.isArray(res?.data) && res?.data?.length > 0) {
                let productObj = res?.data[0] as ILocalQueryObject;
                GlobalStore.externalDetails = productObj
                GlobalStore.entityType = productObj?.entityType
                GlobalStore.entitySubType = productObj?.entitySubType
                GlobalStore.applicationID = productObj?.applicationId
                GlobalStore.isOTCFlow = productObj?.categoryName == "Investment OTC"
                
                // make sure to change
                if (productObj?.entitySubType == "Minor") {
                  setEntitySubType("Minor")
                } else if (productObj?.entityType == "NONINDIVIDUAL" || productObj?.entityType == "NON INDIVIDUAL") {
                  setEntityType("NONINDIVIDUAL")
                  GlobalStore.entityType = "NONINDIVIDUAL"
                } else {
                  setEntitySubType(productObj?.entitySubType)
                  setEntityType(productObj?.entityType)
                }
                GlobalStore.personaldetails.pan = productObj.pan
                setPanFileUploadedLoader(false);
                if (
                  productObj?.createdBy != null &&
                  productObj?.createdBy !== undefined
                ) {
                  setProdObj(productObj);
                  setSkipUrlBoolean(true);
                  setCibilEmailFound(false);
                  setWillDoLater(true);
                  setDobChecked(true);
                  setValues((values) => {
                    if (productObj?.fullname) {
                      values.fullname = productObj.fullname
                    }
                    if (productObj?.pan) {
                      values.pan = productObj.pan;
                      values.minorPan = "yes"
                    }

                    if (productObj?.dob) {
                      values.dob = moment(moment(convertDate(productObj?.dob, false)).toDate())
                        .startOf("day")
                        .toDate();

                      if (ageCalculator(values.dob) > 60) {
                        window.sessionStorage.setItem("isSeniorCitizen", "true");
                      } else {
                        window.sessionStorage.setItem("isSeniorCitizen", "false");
                      }
                    }
                    if (productObj?.firstName) {
                      values.firstName = productObj.firstName;
                    }

                    if (productObj?.middleName) {
                      values.middleName = productObj.middleName;
                    }

                    if (productObj?.lastName) {
                      values.lastName = productObj.lastName;
                    }
                    if (productObj?.leadid) {
                      GlobalStore.leadId = productObj?.leadid;
                    }
                    if (productObj?.email) {
                      GlobalStore.user.email = productObj?.email;
                    }
                    if (productObj?.mobile) {
                      GlobalStore.user.mobile = productObj?.mobile;
                    }
                    if (productObj?.createdBy) {
                      GlobalStore.user.rmCode = productObj?.createdBy;
                    }
                    if (productObj?.accountCategory) {
                      GlobalStore.accountcategory = parseInt(
                        productObj?.accountCategory
                      );
                      GlobalStore.user.accountType =
                        parseInt(productObj?.accountCategory) == 2 ? "I" : "TD";
                    }
                    let PANFirstName = productObj?.firstName;
                    let PANMiddleName = productObj?.middleName ?? "";
                    let PANlastName = productObj?.lastName ?? "";

                    if (PANFirstName === "" && PANlastName !== "") {
                      PANFirstName = PANlastName;
                      GlobalStore.personaldetails.PANName = PANFirstName;
                      PANlastName = "";
                      if (PANMiddleName !== "") {
                        GlobalStore.personaldetails.PANName =
                          GlobalStore.personaldetails.PANName +
                          " " +
                          PANMiddleName;
                      }
                    } else if (
                      PANFirstName === "" &&
                      PANMiddleName === "" &&
                      PANlastName === ""
                    ) {
                      GlobalStore.personaldetails.PANName = "";
                    } else if (PANMiddleName === "") {
                      GlobalStore.personaldetails.PANName =
                        PANFirstName + " " + PANlastName;
                      PANMiddleName = "";
                    } else {
                      GlobalStore.personaldetails.PANName =
                        PANFirstName + " " + PANMiddleName + " " + PANlastName;
                    }


                    //Modify personal details based on this response.

                    GlobalStore.personaldetails.firstname = PANFirstName;
                    GlobalStore.personaldetails.lastname = PANlastName;
                    GlobalStore.personaldetails.middlename = PANMiddleName;
                    GlobalStore.personaldetails.panDetails = {
                      PanNo: values.pan,
                      Firstname: PANFirstName,
                      Middlename: PANMiddleName,
                      Lastname: PANlastName,
                      PANIssueDate: "",
                      AadharSeedingStatus: "",
                      VendorName: "",
                      IsValid: true,
                      IsAadharSeeded: "",
                    };
                    console.log(
                      "PAN DETails---------> external",
                      GlobalStore?.personaldetails?.panDetails
                    );
                    let reqObj: any = {
                      pan: productObj.pan,
                      accountType: productObj?.accountCategory,
                      rmId: productObj?.createdBy,
                    };
                    let newReqObj = {
                      rmid: productObj?.createdBy,
                      skipUrlBoolean: true,
                    };
                    AgetClientDetailsByPANNew(reqObj, newReqObj);
                    return values;
                  });
                  setPanFileUploaded(true);
                }
              }
            }
          },
          {
            id: encodeURIComponent(id),
            name: encodeURIComponent(name),
            stageFlag: 1,
          }
        );
      }
    } else {
      if (fromCibil !== null && fromCibil !== undefined && fromCibil !== "") {
        let fromCibilValue = atob(fromCibil);
        if (fromCibilValue == "true") {
          let cibilData = localStorage.getItem("cibilData");
          if (
            cibilData !== null &&
            cibilData !== undefined &&
            cibilData !== ""
          ) {
            let cibilDataValue = atob(cibilData);
            if (
              cibilDataValue !== null &&
              cibilDataValue !== undefined &&
              cibilDataValue !== ""
            ) {
              let cibilDataObj = JSON.parse(cibilDataValue);
              setPanFileUploadedLoader(false);
              setPanFileUploaded(true);
              setCibilEmailFound(true);
              setWillDoLater(true);
              setDobChecked(true);
              setValues((values) => {
                values.firstName = cibilDataObj?.firstName;
                values.middleName = cibilDataObj?.middleName;
                values.lastName = cibilDataObj?.lastName;
                values.dob = moment(
                  moment(convertDate(cibilDataObj?.birthDate, true)).toDate()
                )
                  .startOf("day")
                  .toDate();
                if (ageCalculator(values.dob) > 60) {
                  window.sessionStorage.setItem("isSeniorCitizen", "true");
                } else {
                  window.sessionStorage.setItem("isSeniorCitizen", "false");
                }
                values.pan = cibilDataObj?.panNo;
                return values;
              });
              localStorage.removeItem("cibilData");
            }
          }
        }
      } else {
        let cibilData = localStorage.getItem("cibilData");
        if (cibilData !== null && cibilData !== undefined && cibilData !== "") {
          let cibilDataValue = atob(cibilData);
          if (
            cibilDataValue !== null &&
            cibilDataValue !== undefined &&
            cibilDataValue !== ""
          ) {
            let cibilDataObj = JSON.parse(cibilDataValue);
            setPanFileUploadedLoader(false);
            setPanFileUploaded(true);
            setCibilEmailFound(true);
            setWillDoLater(true);
            setDobChecked(true);
            setValues((values) => {
              values.firstName = cibilDataObj?.firstName;
              values.middleName = cibilDataObj?.middleName;
              values.lastName = cibilDataObj?.lastName;
              values.dob = moment(moment(convertDate(cibilDataObj?.birthDate, true)).toDate())
                .startOf("day")
                .toDate();
              if (ageCalculator(values.dob) > 60) {
                window.sessionStorage.setItem("isSeniorCitizen", "true");
              } else {
                window.sessionStorage.setItem("isSeniorCitizen", "false");
              }
              values.pan = cibilDataObj?.panNo;
              return values;
            });
            localStorage.removeItem("cibilData");
          }
        }
      }
      if (!GlobalStore.user.email || !GlobalStore.user.mobile) {
        if (!!navigateURL) {
          setSkipUrlBoolean(false);
          setCibilEmailFound(false);
          window.location.href = navigateURL;
        }
      }
    }
  }, []);

  React.useEffect(() => {
    if (GlobalStore.personaldetails.PANName)
      window.sessionStorage.setItem("clientNameNew", GlobalStore.personaldetails.PANName)
  }, [GlobalStore.personaldetails.PANName])

  // Clervertap event: pan screen is loaded
  React.useEffect(() => {
    const data = {
      EventName: cleverTapEvents.registration.panPage.PAGE_LOAD,
      InitiationPlatform: "",
      UTM_SOURCE,
      UTM_MEDIUM,
      UTM_CAMPAIGN,
      LEAD_ID: GlobalStore.leadId,
      REF_ID: "",
    };
    ClevertapService.pushEvent(data);
  }, []);

  React.useEffect(() => {
    console.log("applicationModeType", applicationModeType);
    if (applicationModeType === "isKRA") {
      setModalDisplayText(
        "As per SEBI Regulations, under the Income Tax Guidelines we have successfully verified your Name on the Income Tax Website. Your application is pre-filled since you are an existing KRA Validated Customer."
      );
    } else if (applicationModeType === "isDigiLocker") {
      setModalDisplayText(
        "As per SEBI Regulations, under the Income Tax Guidelines we have successfully verified your Name on the Income Tax Website. We suggest completing your journey using Digilocker. For Using Digilocker your Aadhar and Mobile should be linked. It is not mandatory to have a Digilocker account. This will help you to speed up your activation process."
      );
    }
  }, [applicationModeType]);

  const registerCleverTapEventAfterProceed = () => {
    const data = {
      EventName: cleverTapEvents.registration.panPage.CLICK_ON_PROCEED,
      InitiationPlatform: "",
      UTM_SOURCE,
      UTM_MEDIUM,
      UTM_CAMPAIGN,
      LEAD_ID: GlobalStore.leadId,
      REF_ID: GlobalStore.applicationID,
      KRA: GlobalStore.isKRA,
      ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
    };
    ClevertapService.pushEvent(data);

    // Apps flyer event for click on proceed on pan details page
    AppsFlyerService.pushEvent(
      appsFlyerEvents.registration.panPage.CLICK_ON_PROCEED
    );
  };

  function init() {
    //CleverTap log start
    /*
        var data = {
            CurrentPage: $location.path(),
            Platform: angular.element($window).width() > 767 ? 'Website_Desktop' : 'Website_Mobile',
            EventName: 'Pan_dob_view'
        };
        clevertap.event.push(data.EventName, data);
        */
    //CleverTap log end

    window.sessionStorage.setItem("isSeniorCitizen", "false");
    window.localStorage.removeItem("isAadhaarVerified");
    GlobalStore.personaldetails = {
      firstname: GlobalStore.user.firstname,
      lastname: GlobalStore.user.lastName,
      middlename: "",
      mobile: GlobalStore.user.mobile,
      emailId: GlobalStore.user.email,
      aadhaar: "",
      pan: "",
      gender: "",
      dob: "",
      additionalemail: "",
      additionalmobile: "",
      PANName: "",
      adrLine1: "",
      adrLine2: "",
      city: "",
      state: "",
      pincode: "",
    };
  }

  function onChange(key: keyof IPanDobFields, value: string | Date) {
    if (key == 'minorPan') {
      values.pan = ""
      errors.pan = ""
    }
    if (
      key === "pan" &&
      typeof value === "string" &&
      !alphaNumExp.test(value)
    ) {
      value = values[key];
    }
    if (key === "pan") setValidPan(false);
    if (key === "aadharLinked" && typeof value === "string")
      gtmService({
        action: "PAN_DOB",
        label: `AADHAR_LINK | ${value.toUpperCase()}`,
      });
    if (key === "dob" && typeof value !== "string") {
      console.log("onChange 1");
      setErrCode(errCode);
      if (ageCalculator(value) >= 60)
        window.sessionStorage.setItem("isSeniorCitizen", "true");
      else window.sessionStorage.setItem("isSeniorCitizen", "false");
      console.log(moment(value).format("YYYY-MM-DD"), " || ", panDobState);
      if (moment(value).format("YYYY-MM-DD") === panDobState) {
        setDobChecked(true);
        setRemovePanImg(false);
        setErrCode("");
        console.log("onChange 2");
      } else {
        console.log("onChange 3");
        setDobChecked(false);
      }
    }
    console.log("errors", errors);
    setErrors({ ...errors, [key]: "" });
    setValues({ ...values, [key]: value });
  }

  function onBlurPan(error: any) {
    if (values.pan) {
      setErrors({
        ...errors,
        pan: error.pattern ? "" : errorMsg(errorCode.FE07),
      });
    } else {
      setErrors({
        ...errors,
        pan: error.pattern ? "" : errorMsg(errorCode.FE09),
      });
    }
  }

  function onBlurDob(event: React.FocusEvent<HTMLInputElement>) {
    if (!values.dob) {
      // setErrors({ ...errors, dob: 'Please select a valid date' });
      setErrors({ ...errors, dob: errorMsg(errorCode.FE10) });
    }
  }
  const UccCheckNewCalled = (res: any, callBackFunction: Function) => {
    if (!res || res.error) {
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }

      setIsLoading(false);
      gtmService({ action: "CheckUCCExists", label: "ERROR || ERR105" });
    } else {
      if (
        !!res?.data &&
        res?.data?.Source === 1 &&
        res?.data?.IbeatsCheck !== null &&
        res?.data?.IbeatsCheck !== undefined &&
        res?.data?.IbeatsCheck
      ) {
        registerCleverTapEventAfterProceed();
        gtmService({ action: "PAN_DOB", label: "Step_Complete" });
        // history.push(containerUrl.accexists);
        navigate(containerUrl.accexists)
        setIsLoading(false);
      } else if (
        !!res?.data &&
        res?.data?.Source === 2 &&
        res?.data?.UccCheck !== null &&
        res?.data?.UccCheck !== undefined &&
        res?.data?.UccCheck
      ) {
        callBackFunction();
      }
    }
  };
  const panFunction = () => {
    panValidation(
      {
        panNo: values.pan || values?.gurdianPanNo,
        name:
          values.firstName +
          " " +
          (values?.middleName ?? "" + " ") +
          values.lastName,
        dob: moment(values.dob).format("DD/MM/YYYY"),
        source: "DIY",
      },
      () => { }
    );
  };

  function handleSubmit(e?: any) {
    e.preventDefault();
    setErrCode("");
    setIsLoading(true);
    setSubmitFlag(false);

    const {
      pan,
      gurdianPanNo,
      dob,
      gurdianDOB
    } = values;
    const activePan: any = pan;
    const isValidPan = panRegex.test(activePan);


    if (!activePan || !isValidPan) {
      setErrCode("Invalid PAN");
      return setIsLoading(false);
    }

    // --- Check for minor ---
    if (isMinor(dob)) {
      setErrCode("The PAN belongs to a minor.");
      return setIsLoading(false);
    }

    const accountType = getProductCode() === "I" ? 2 : 1;

    const proceedAfterPan = () => {
      AGetEmployeeByPan(checkIsPanEmployee, values.pan || values.gurdianPanNo);

      const name =
        `${values?.firstName ?? ""} ${values?.middleName ?? ""} ${values?.lastName ?? ""}`.trim();

      ACheckUCCExists(
        (res: any) => {
          UccCheckNewCalled(res, panFunction);
        },
        values.pan || values.gurdianPanNo,
        GlobalStore.user.mobile,
        GlobalStore.user.email,
        GlobalStore.leadId,
        prodObj?.createdBy ? parseInt(prodObj.createdBy) : 0,
        accountType,
        getProductCode(),
        name,
        values?.dob,
        ""
      );
    };
    setValidPan(true);
    setPanInvalidMsg("");
    proceedAfterPan();
    // setIsLoading(false);
  }


  function checkIsPanEmployee(res: any) {
    if (res && res.status) {
      const responseDataObj = res.data;
      if (responseDataObj.result.Flag === "Y") isEmployee = true;
    } else {
      if (!res || res.error) {
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        gtmService({
          action: "GetEmployeeDetailsByPAN",
          label: "ERROR || ERR109",
        });
      }
    }
  }

  function checkPendingUploadNew(res: any, reqObj?: any) {
    let dematAccountFoundLocal: any = null;
    if (!res || res.error) {
      // setErrCode('1221 - Error in fetching pending document upload list.');
      //   setErrCode(errorMessage.checkPendingUpload);
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR112" });
      setIsLoading(false);
    } else {
      if (res && res?.data == null) {
        let isUploadDocumentsCompleted: boolean = false;
        AGetStageCompletionStatus(
          (res: any) =>
            getClientStageDetailsNew(res, isUploadDocumentsCompleted, reqObj),
          GlobalStore.applicationID
        );
      } else if (res && res.data !== null) {
        const list: Array<any> = JSON.parse(res.data).filter(
          (item: any) => item.Mandatory == true
        );
        let isUploadDocumentsCompleted: boolean = false;
        if (
          list !== undefined &&
          list !== null &&
          list?.length > 0 &&
          list?.length === 1
        ) {
          dematAccountFoundLocal = list.find(
            (listObj) =>
              listObj?.DocumentCategory == "DP Document" &&
              listObj?.DocumentCategoryId == 96
          );
          if (
            dematAccountFoundLocal !== undefined &&
            dematAccountFoundLocal !== null
          ) {
            setDematAccountFound((dematAccountFound: any) => {
              dematAccountFound = dematAccountFoundLocal;
              return dematAccountFound;
            });
            //  completeModuleStatus(dashboardUrl.demat);
            // history.push(dashboardUrl.demat);
            // return;
          }
        }
        if (
          list !== undefined &&
          list !== null &&
          list?.length > 0 &&
          list?.length > 1
        ) {
          dematAccountFoundLocal = list.find(
            (listObj) =>
              listObj?.DocumentCategory == "DP Document" &&
              listObj?.DocumentCategoryId == 96
          );
          if (
            dematAccountFoundLocal !== undefined &&
            dematAccountFoundLocal !== null
          ) {
            setDematAccountFound((dematAccountFound: any) => {
              dematAccountFound = dematAccountFoundLocal;
              return dematAccountFound;
            });
            //  completeModuleStatus(dashboardUrl.demat);
            // history.push(dashboardUrl.demat);
            // return;
          }
        }
        if (list.length === 0 || list[0].count === 0)
          isUploadDocumentsCompleted = true;

        AGetStageCompletionStatus(
          (res: any) =>
            getClientStageDetailsNew(
              res,
              isUploadDocumentsCompleted,
              reqObj,
              dematAccountFoundLocal
            ),
          GlobalStore.applicationID
        );
      } else {
        // setErrCode('1222 - Error in fetching pending document upload list.');
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }
  const getCheckedDobCondition = () => {
    let disabledCondition: boolean = false;
    if (
      prodObj?.createdBy !== null &&
      prodObj?.createdBy !== undefined &&
      prodObj?.createdBy !== 0 &&
      prodObj?.dob != undefined &&
      prodObj?.dob !== null &&
      prodObj?.dob !== "" &&
      values?.dob !== null &&
      values?.dob !== undefined &&
      values?.dob ===
      moment(moment(convertDate(prodObj?.dob)).toDate())
        .startOf("day")
        .toDate()
    ) {
      disabledCondition = true;
    }
    return disabledCondition;
  };
  function getClientStageDetailsNew(
    res: any,
    isUploadDocumentsCompleted: boolean,
    reqObj?: any,
    dematAccountFoundLocaL?: any
  ) {
    if (!res || res.error) {
      // setErrCode('1061 - Error in fetching stage completion details.');
      // setErrCode(errorMessage.getClientStageDetails);
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({
        action: "GetStageCompletionStatus",
        label: "ERROR || ERR113",
      });
      setIsLoading(false);
    } else {
      if (res.data && res.data !== null) {
        const responseObj = JSON.parse(res.data);
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        setStageData(responseObj);
        //check completeness of stages
        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound
        );
        console.log(clientPartialDetails_ao, "clientPartialDetails_ao");

        if (!clientPartialDetails_ao.mobile) {
          clientPartialDetails_ao.mobile = responseObj.mobileno;
        }

        if (!clientPartialDetails_ao.emailID) {
          clientPartialDetails_ao.emailID = responseObj.emailid;
        }
        clientPartialDetails_ao.pan = GlobalStore.personaldetails.pan;

        clientPartialDetails_ao.clientPrimaryDetailId =
          GlobalStore.clientPrimaryDetailId;
        clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
        clientPartialDetails_ao.accountcategory = GlobalStore.accountcategory;
        clientPartialDetails_ao.token = GlobalStore.token;
        if (
          responseObj?.fatherspousename != null &&
          responseObj?.fatherspousename != undefined &&
          responseObj?.fatherspousename !== ""
        ) {
          clientPartialDetails_ao.fsfullName = responseObj?.fatherspousename;
        }
        clientPartialDetails_ao.dpid = responseObj?.dpid;
        clientPartialDetails_ao.clientid = responseObj?.dpclientid;
        GlobalStore.dpid = responseObj?.dpid;
        GlobalStore.clientid = responseObj?.dpclientid;
        GlobalStore.entityType = responseObj?.entitytype;
        GlobalStore.entitySubType = responseObj?.entitysubtype
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        //set stage api data to GlobalStore
        setStageData(responseObj);
        let cacheData = null;
        //check completeness of stages
        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound
        );
        setCheckpanaaddharflag(responseObj.checkpanaaddharflag);
        setStageBooleanFlags((stageBooleanFlags) => {
          stageBooleanFlags.isPersonalStage =
            responseObj?.ispersonaldetailscompleted;
          stageBooleanFlags.isProfileStage =
            responseObj?.isprofiledetailscompleted;
          return stageBooleanFlags;
        });

        if (
          reqObj?.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined
        ) {
          if (
            !(
              responseObj.isprofiledetailscompleted &&
              responseObj.ispersonaldetailscompleted
            )
          ) {
          }
          if (responseObj?.isaddressstagecompleted == false && !responseObj?.isotc) {
            GlobalStore.nextIncompleteStage = dashboardUrl.personalIfo;
          } else GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        }

        if (responseObj.iskyc) GlobalStore.isKYC = true;

        if (
          !(
            responseObj.isprofiledetailscompleted &&
            responseObj.ispersonaldetailscompleted
          )
        ) {
          if (responseObj?.isaddressstagecompleted == false && !responseObj?.isotc) {
            GlobalStore.nextIncompleteStage = dashboardUrl.personalIfo;
          } else GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        } else if (!responseObj.isbankdetailscompleted) {
          GlobalStore.nextIncompleteStage = dashboardUrl.bank;
        } else if (
          responseObj?.accountcategory === 2 &&
          !responseObj?.isdpcompleted
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.demat;
        else if (!isUploadDocumentsCompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.doc;
        else if (
          responseObj.applicationstatus === 1 &&
          responseObj.bpm_pd_status === 0
        )
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress)
        else if (responseObj.bpm_pd_status === 1)
          // history.push(containerUrl.poa);
          navigate(containerUrl.poa)
        let newReqObj = reqObj;
        newReqObj.isKra = responseObj.iskra;
        if (!isUploadDocumentsCompleted && responseObj.bpm_pd_status === 2) {
          // history.push(statusUrl.documentReject);
          navigate(statusUrl.documentReject)
          return;
        } else if (
          isUploadDocumentsCompleted == true &&
          responseObj.bpm_pd_status === 2
        ) {
          QCServiceTaskCreation(
            (res: any) => {
              if (!res || res.error) {
                setIsLoading(false);
                setErrCode(res.error);
              } else {
                if (
                  res &&
                  res.data !== null &&
                  Object.keys(res?.data)?.length > 0
                ) {
                  // history.push(statusUrl.docVerificationInProgress);
                  navigate(statusUrl.docVerificationInProgress)
                  return
                } else {
                  setErrCode("Something went wrong. please try again later.");
                  setIsLoading(false);
                }
              }
            },
            GlobalStore?.applicationID,
            GlobalStore.stageStatus.accountcategory
              ? GlobalStore?.stageStatus?.accountcategory
              : 0
          );
        }
        if (
          reqObj?.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined &&
          responseObj.applicationstatus === 1 &&
          responseObj.bpm_pd_status === 0
        ) {
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress)
        } else if (
          reqObj?.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined &&
          responseObj.applicationstatus === 1 &&
          responseObj.bpm_pd_status === 1
        ) {
          if (
            responseObj.isesigncompleted !== null &&
            responseObj.isesigncompleted == true &&
            responseObj?.auth_ver &&
            responseObj?.accountcategory === 2 &&
            responseObj?.elog_opted &&
            responseObj.isKra
          ) {
            // history.push(statusUrl.elogVerificationInProgress);
            navigate(statusUrl.elogVerificationInProgress)
          } else if (
            responseObj.isesigncompleted !== null &&
            responseObj.isesigncompleted == true &&
            responseObj?.auth_ver &&
            responseObj?.accountcategory === 2
          ) {
            // history.push(containerUrl.esignsubmit);
            navigate(containerUrl.esignsubmit)
          } else {
            if (
              responseObj.iskra !== null &&
              responseObj.iskra !== undefined &&
              responseObj?.auth_ver
            ) {
              // history.push(containerUrl.kycsubmit);
              navigate(containerUrl.kycsubmit)
              // } else history.push(containerUrl.kycsubmit);
            } else navigate(containerUrl.kycsubmit)
          }
        } else savePanDob(true, true, newReqObj);
      } else {
        // setErrCode('1062 - Error in fetching stage completion details.');
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }
  const AgetClientDetailsByPANNew = (reqObj: any, newReqObj?: any) => {
    AGetClientDetailsByPan(
      (res: any) => {
        if (!res || res.error) {
          // setErrCode('118 - Error in fetching Client details from our system.');
          // setErrCode(errorMessage.searchByPan);
          if (errCode?.includes(res.error)) {
            setErrCode(errCode);
          } else {
            setErrCode(errCode + res.error);
          }
          gtmService({
            action: "GetClientDataByPanOrLead",
            label: "ERROR || ERR102",
          });
          setIsLoading(false);
        } else {
          if (res.data !== null) {
            if (res.data !== null && res.data != "Records Not Found") {
              GlobalStore.personaldetails.pan = res.data.PAN;
              GlobalStore.token = res.data.Token;
              GlobalStore.applicationID = res.data.ApplicatoinId;
              GlobalStore.leadId = res.data.LeadId;
              GlobalStore.accountcategory = res.AccountCategory;
              GlobalStore.clientPrimaryDetailId =
                res.data.ClientPrimaryDetailId;
              const clientPartialDetails_ao = JSON.parse(
                window.localStorage.getItem("clientPartialDetails_ao") || "{}"
              );
              clientPartialDetails_ao.pan = res.data.Token;
              clientPartialDetails_ao.clientPrimaryDetailId =
                res.ClientPrimaryDetailId;
              clientPartialDetails_ao.applicationId = res.ApplicatoinId;
              clientPartialDetails_ao.accountcategory = res.AccountCategory;
              clientPartialDetails_ao.token = res.data.Token;
              window.localStorage.setItem(
                "clientPartialDetails_ao",
                JSON.stringify(clientPartialDetails_ao)
              );
              APendingUploadList((res: any) => {
                checkPendingUploadNew(res, newReqObj);
              }, GlobalStore.applicationID);
            }
          } else {
            // setErrCode('1182 - Error in fetching Client details from our system.');
            if (errCode?.includes(res.error)) {
              setErrCode(errCode);
            } else {
              setErrCode(errCode + res.error);
            }
            setIsLoading(false);
          }
        }
      },
      reqObj.pan,
      reqObj.accountType,
      reqObj.rmId
    );
  };
  const validatePANNew = (
    seedingStatus?: string,
    SeedingStatusMsg?: string,
    PanStatus?: string
  ) => {
    let PANFirstName = values?.firstName;
    let PANMiddleName = values.middleName ?? "";
    let PANlastName = values?.lastName ?? "";

    if (PANFirstName === "" && PANlastName !== "") {
      PANFirstName = PANlastName;
      GlobalStore.personaldetails.PANName = PANFirstName;
      PANlastName = "";
      if (PANMiddleName !== "") {
        GlobalStore.personaldetails.PANName =
          GlobalStore.personaldetails.PANName + " " + PANMiddleName;
      }
    } else if (
      PANFirstName === "" &&
      PANMiddleName === "" &&
      PANlastName === ""
    ) {
      GlobalStore.personaldetails.PANName = "";
    } else if (PANMiddleName === "") {
      GlobalStore.personaldetails.PANName = PANFirstName + " " + PANlastName;
      PANMiddleName = "";
    } else {
      GlobalStore.personaldetails.PANName =
        PANFirstName + " " + PANMiddleName + " " + PANlastName;
    }

    //Modify personal details based on this response.
    console.log(
      "PAN DETails",
      GlobalStore?.personaldetails?.panDetails,
      SeedingStatusMsg,
      PanStatus
    );
    GlobalStore.personaldetails.firstname = PANFirstName;
    GlobalStore.personaldetails.lastname = PANlastName;
    GlobalStore.personaldetails.middlename = PANMiddleName;
    GlobalStore.personaldetails.panDetails = {
      PanNo: values.pan,
      Firstname: PANFirstName,
      Middlename: PANMiddleName,
      Lastname: PANlastName,
      PANIssueDate: "",
      AadharSeedingStatus: SeedingStatusMsg,
      VendorName: "",
      IsValid: PanStatus === "Y" ? true : false,
      IsAadharSeeded: seedingStatus,
    };
    console.log("PAN DETails", GlobalStore?.personaldetails?.panDetails);
    if (seedingStatus === "N") {
      GlobalStore.isSeeding = false;
    } else {
      GlobalStore.isSeeding = true;
    }
    let accountType = getProductCode() == "I" ? 2 : 1;
    if (getProductCode() == "I") {
      accountType = 2;
    }
    AGetClientDetailsByPan(
      searchByPan,
      values.pan || values?.gurdianPanNo,
      accountType,
      objAccType === "RMINV" ? objUtm.utm_campaign : skipUrlBoolean &&
        prodObj?.createdBy != null &&
        prodObj?.createdBy !== undefined
        ? prodObj?.createdBy
        : GlobalStore?.user?.userId
    );
    //ACheckPanIbeats(checkedPanInIbeats, values.pan);
  };

  function searchByPan(res: any) {
    if (!res || res.error) {
      // setErrCode('118 - Error in fetching Client details from our system.');
      // setErrCode(errorMessage.searchByPan);
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({
        action: "GetClientDataByPanOrLead",
        label: "ERROR || ERR102",
      });
      setIsLoading(false);
    } else {
      if (res.data !== null) {
        if (res.data !== null && res.data != "Records Not Found") {
          GlobalStore.personaldetails.pan = res.data.PAN;
          GlobalStore.token = res.data.Token;
          GlobalStore.applicationID = res.data.ApplicatoinId;
          GlobalStore.leadId = res.data.LeadId;
          GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
          GlobalStore.accountcategory = res.AccountCategory;
          APendingUploadList(checkPendingUpload, GlobalStore.applicationID);
        } else {
          savePanDob();
        }
        //  else if (res.data == "Records Not Found") {
        //   AGetClientDetailsByLeadId(
        //     searchByLeadId,
        //     GlobalStore.leadId,
        //     getProductCode(),
        //     GlobalStore?.user?.userId
        //   );
        // }
      } else if (res.data === null) {
        savePanDob();
      } else {
        // setErrCode('1182 - Error in fetching Client details from our system.');
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }

  function searchByLeadId(res: any) {
    if (!res || res.error) {
      // setErrCode('119 - Error in fetching Client details from our system.');
      // setErrCode(errorMessage.searchByLeadId);
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({
        action: "GetClientDataByPanOrLead",
        label: "ERROR || ERR103",
      });
      setIsLoading(false);
    } else {
      console.log("UCC Check 1");
      if (res.data && res.data != null) {
        GlobalStore.token = res.data.Token;
        GlobalStore.applicationID = res.data.ApplicatoinId;
        GlobalStore.personaldetails.pan = res.data.PAN;
        GlobalStore.leadId = res.data.LeadId;
        GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
        APendingUploadList(checkPendingUpload, GlobalStore.applicationID);

        // if (
        //   GlobalStore.personaldetails.pan.toUpperCase().trim() ===
        //   res.data.PAN.toUpperCase().trim()
        // ) {
        //   GlobalStore.token = res.data.Token;
        //   GlobalStore.applicationID = res.data.ApplicatoinId;
        //   GlobalStore.personaldetails.pan = res.data.PAN;
        //   GlobalStore.leadId = res.data.LeadId;
        //   GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
        //   APendingUploadList(checkPendingUpload, GlobalStore.applicationID);
        // } else {
        //   console.log("DUP block");
        //   // create Lead without dudupe
        //   // GlobalStore.createLeadDudupeParam.byPassDedupe = true;
        //   // ACreateLead(leadCreated, GlobalStore.createLeadDudupeParam);
        //   // ACreateLeadSource(leadCreated, GlobalStore.createLeadDudupeParam);
        //   // savePanDob();
        // }
      } else if (res.data == null) {
        console.log("UCC Check 2");

        savePanDob();
      } else {
        // setErrCode('1192 - Error in fetching Client details from our system.');
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }

  function leadCreated(res: any) {
    if (!res || res.error) {
      // setErrCode('103 - Error in generating new Lead.');
      // setErrCode(errorMessage.leadCreated);
      setErrCode(res.error);
      gtmService({ action: "CreateLead", label: "ERROR || ERR111" });
      setIsLoading(false);
    } else {
      if (res && res.data) {
        const response = JSON.parse(res.data);
        if (response && response.LeadId) {
          GlobalStore.leadId = response.LeadId;
          savePanDob();
        }
      } else {
        // setErrCode('104 - Error in generating new Lead.');
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }
  const cacheKRAFunction = (
    responseObj: any,
    skipSavePANDOB?: boolean,
    reqObj?: any
  ) => {
    GlobalStore.isKRA = true;
    if (applicationModeType !== "isKRA") {
      console.log("setApplicationModeType 4");
      setApplicationModeType("isKRA");
    }
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    GlobalStore.KRA_email = responseObj.KraEmail ? responseObj.KraEmail : "";
    GlobalStore.KRA_mobile = responseObj.KraMobile ? responseObj.KraMobile : "";
    GlobalStore.KRA_mode = responseObj.kra_mode ? responseObj.kra_mode : 0;

    // if (!GlobalStore.isKYC) {
    const resultObj = responseObj;
    GlobalStore.kraInfoObject.addressLine1 = `${resultObj.AppPerAdd1} ${resultObj.AppPerAdd2 || ""
      } ${resultObj.AppPerAdd3 || ""}`;
    GlobalStore.kraInfoObject.addressLine1 =
      GlobalStore.kraInfoObject.addressLine1; //.replace(/[^a-zA-Z0-9 ]/g, " ")

    GlobalStore.kraInfoObject.corrAddress = `${resultObj.AppCorAdd1} ${resultObj.AppCorAdd2 || ""
      } ${resultObj.AppCorAdd3 || ""}`;
    GlobalStore.kraInfoObject.corrAddress =
      GlobalStore.kraInfoObject.corrAddress; //.replace(/[^a-zA-Z0-9 ]/g, " ")
    GlobalStore.kraInfoObject.pincode = resultObj.AppPerPincd;
    GlobalStore.kraInfoObject.corrPincode = resultObj.AppCorPincd;
    GlobalStore.personaldetails.fsfullName = resultObj.FatherName
      ? resultObj.FatherName
      : GlobalStore.personaldetails.fsfullName;
    clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
    clientPartialDetails_ao.gender = responseObj?.Gender;
    GlobalStore.personaldetails.gender = responseObj?.Gender;
    clientPartialDetails_ao.addressLine1 =
      GlobalStore.kraInfoObject.addressLine1;
    clientPartialDetails_ao.pincode = GlobalStore.kraInfoObject.pincode;
    clientPartialDetails_ao.corrAddress = GlobalStore.kraInfoObject.corrAddress;
    clientPartialDetails_ao.corrPincode = GlobalStore.kraInfoObject.corrPincode;
    clientPartialDetails_ao.fsfullName = GlobalStore.personaldetails.fsfullName;
    clientPartialDetails_ao.sameAsPermanent =
      GlobalStore.kraInfoObject.addressLine1 ==
        GlobalStore.kraInfoObject.corrAddress
        ? true
        : false;
    // } else {
    //     clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
    // }'
    if (skipSavePANDOB) {
      clientPartialDetails_ao.pan = GlobalStore?.personaldetails.pan;
      clientPartialDetails_ao.clientPrimaryDetailId =
        GlobalStore?.clientPrimaryDetailId;
      clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
      clientPartialDetails_ao.accountcategory = GlobalStore?.accountcategory;
      clientPartialDetails_ao.token = GlobalStore?.token;
      clientPartialDetails_ao.leadID = GlobalStore.leadId;
    }
    window.localStorage.setItem(
      "clientPartialDetails_ao",
      JSON.stringify(clientPartialDetails_ao)
    );
    GlobalStore.dateofbirth = moment(values.dob).format("MM/DD/YYYY");
    GlobalStore.dateOfIncorporation = moment(values.dob).format("YYYY-MM-DD");
    if (skipSavePANDOB) {
      menuOption(reqObj, () => {
        // history.push(dashboardUrl.profile);
        navigate(dashboardUrl.profile)
      });
    } else dobMatched({}, true, true);
    // getKraDocumentUpload(responseObj, true);
    // setTimeout(()=>{

    // },3000)
  };
  const menuOption = (reqObj?: any, redirctTo?: Function) => {
    if (
      reqObj.skipUrlBoolean &&
      reqObj?.rmid !== null &&
      reqObj?.rmid !== undefined
    ) {
      // if (!reqObj?.isKra || isPanLinkedToAadhar !== true) {
      //   let filterLeftBar = leftNavBarArray;
      //   let filterNavIndex = filterLeftBar?.findIndex(
      //     (filter) => filter?.navUrl == "/plan"
      //   );
      //   if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
      //   let filterNavIndex2 = filterLeftBar?.findIndex(
      //     (filter) => filter?.navUrl == dashboardUrl.eSign
      //   );
      //   if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
      //   let filterNavIndex3 = filterLeftBar?.findIndex(
      //     (filter) => filter?.navUrl == dashboardUrl.profiler
      //   );
      //   if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
      //   let filterNavIndex4 = filterLeftBar?.findIndex(
      //     (filter) => filter?.navUrl == dashboardUrl.ipv
      //   );
      //   if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
      //   if (!filterLeftBar?.includes(dematNavBarObj))
      //     filterLeftBar.push(dematNavBarObj);
      //   GlobalStore.leftNavBarState = filterLeftBar;
      // } else {
      //   setDobChecked(true);
      //   let filterLeftBar = leftNavBarArray;
      //   let filterNavIndex = filterLeftBar?.findIndex(
      //     (filter) => filter?.navUrl == "/plan"
      //   );
      //   if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
      //   let filterNavIndex2 = filterLeftBar?.findIndex(
      //     (filter) => filter?.navUrl == dashboardUrl.eSign
      //   );
      //   if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
      //   let filterNavIndex3 = filterLeftBar?.findIndex(
      //     (filter) => filter?.navUrl == dashboardUrl.profiler
      //   );
      //   if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
      //   let filterNavIndex4 = filterLeftBar?.findIndex(
      //     (filter) => filter?.navUrl == dashboardUrl.ipv
      //   );
      //   if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
      //   if (!filterLeftBar?.includes(dematNavBarObj))
      //     filterLeftBar.push(dematNavBarObj);
      //   GlobalStore.leftNavBarState = filterLeftBar;
      // }
      if (redirctTo !== undefined) redirctTo();
    }
  };
  const originalSavePANDOB = (
    applicationIdExists?: boolean,
    skipSavePANDOB?: boolean,
    reqObj?: any
  ) => {
    if (
      applicationIdExists &&
      (GlobalStore.stageStatus.ispersonaldetailscompleted ||
        GlobalStore.stageStatus.isprofiledetailscompleted)
    ) {
      const clientPartialDetails_ao = JSON.parse(
        window.localStorage.getItem("clientPartialDetails_ao") || "{}"
      );

      clientPartialDetails_ao.PANName = GlobalStore.personaldetails.PANName;
      clientPartialDetails_ao.aadharLinkedChoice =
        GlobalStore.aadharLinkedChoice;
      clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
      clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
      clientPartialDetails_ao.ckycNo = GlobalStore.stageStatus.ckycnumber;
      clientPartialDetails_ao.clientPrimaryDetailId =
        GlobalStore.clientPrimaryDetailId;
      clientPartialDetails_ao.dob = GlobalStore.dob;
      clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
      clientPartialDetails_ao.emailID = GlobalStore.user.email;
      clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
      clientPartialDetails_ao.isKRA = GlobalStore.stageStatus.iskra;
      clientPartialDetails_ao.isKYC = GlobalStore.stageStatus.iskyc;

      clientPartialDetails_ao.isSeniorCitizen =
        window.sessionStorage.getItem("isSeniorCitizen") === "true"
          ? true
          : false;
      clientPartialDetails_ao.leadID = GlobalStore.leadId;
      clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
      clientPartialDetails_ao.pan = values.pan || values.gurdianPanNo;
      clientPartialDetails_ao.panDetails =
        GlobalStore.personaldetails.panDetails;
      clientPartialDetails_ao.token = GlobalStore.token;
      clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
      // if(GlobalStore?.applicationID && GlobalStore?.isDigiLocker){
      //   setShowSubmitModal(true);
      // }
      window.localStorage.setItem(
        "clientPartialDetails_ao",
        JSON.stringify(clientPartialDetails_ao)
      );
      registerCleverTapEventAfterProceed();
      gtmService({ action: "PAN_DOB", label: "Step_Complete" });
      if (GlobalStore?.applicationID && GlobalStore?.isDigiLocker) {
        // history.push(GlobalStore?.nextIncompleteStage);
        navigate(GlobalStore?.nextIncompleteStage)
      } else {
        if (skipSavePANDOB) {
          menuOption(reqObj, () => {
            navigateTo(applicationIdExists, reqObj);
          });
        } else navigateTo(applicationIdExists);
      }
    } else {
      GlobalStore.dateofbirth = moment(values.dob).format("MM/DD/YYYY");
      GlobalStore.dob = moment(values.dob).format("MM/DD/YYYY");
      GlobalStore.dateOfIncorporation = moment(values.dob).format("YYYY-MM-DD");
      GlobalStore.birthDate = moment(values.dob).format("MM/DD/YYYY");
      if (skipSavePANDOB) {
        let clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao = {
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
          token: GlobalStore.token,
          applicationId: GlobalStore.applicationID,
          dob: GlobalStore.dob,
          dateOfIncorporation: GlobalStore.dateOfIncorporation,
          birthDate: GlobalStore.birthDate,
          pan: values.pan,
          aadharLinkedChoice: GlobalStore.aadharLinkedChoice,
          leadID: GlobalStore.leadId,
          emailID: GlobalStore.user.email,
          mobile: GlobalStore.user.mobile,
          panDetails: GlobalStore.personaldetails.panDetails,
          PANName: GlobalStore.personaldetails.PANName,
          isSeniorCitizen:
            window.sessionStorage.getItem("isSeniorCitizen") === "true"
              ? true
              : false,
          isDigiLocker: GlobalStore.isDigiLocker,
          isKRA: false,
          isKYC: false,
          isSeeding: GlobalStore.isSeeding,
          selfieUrl: GlobalStore.selfieUrl,
          isManual: false,
          aadharNo: GlobalStore.personaldetails.aadharNo,
          addressLine1: GlobalStore.addressLine1,
          corrAddress: GlobalStore.corrAddress,
          PinCode: GlobalStore.PinCode,
          corrPincode: GlobalStore.corrPincode,
          sameAsPermanent: GlobalStore.sameAsPermanent,
        };
        window.localStorage.setItem(
          "aadharNumber",
          GlobalStore.personaldetails.aadharNo
        );
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        if (
          reqObj.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined
        ) {
          if (!reqObj?.isKra || isPanLinkedToAadhar !== true) {
            let filterLeftBar = leftNavBarArray;
            let filterNavIndex = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == "/plan"
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
            let filterNavIndex2 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.eSign
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
            let filterNavIndex3 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.profiler
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
            let filterNavIndex4 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.ipv
            );
            if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
            if (!filterLeftBar?.includes(dematNavBarObj))
              filterLeftBar.push(dematNavBarObj);
            GlobalStore.leftNavBarState = filterLeftBar;
          } else {
            //  setShowSubmitModal(true);
            setDobChecked(true);
            // if (applicationModeType !== "isKRA") {
            //   setApplicationModeType("isKRA");
            // }
            let filterLeftBar = leftNavBarArray;
            let filterNavIndex = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == "/plan"
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);
            let filterNavIndex2 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.eSign
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex2, 1);
            let filterNavIndex3 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.profiler
            );
            if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex3, 1);
            let filterNavIndex4 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.ipv
            );
            if (filterNavIndex4 > 0) filterLeftBar?.splice(filterNavIndex4, 1);
            if (!filterLeftBar?.includes(dematNavBarObj))
              filterLeftBar.push(dematNavBarObj);
            GlobalStore.leftNavBarState = filterLeftBar;
          }
        }
        if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
          setShowSubmitModal(true);
        }
        navigateTo(applicationIdExists, reqObj);
      } else {
        if (isPanLinkedToAadhar == true) {
          // AGetCkycNumber(
          //   (res: any) => getCkycNumber(res, applicationIdExists),
          //   values.pan
          // );
          dobMatched({});
        } else {
          GlobalStore.isKYC = false;
          GlobalStore.isKRA = false;
          const clientPartialDetails_ao = JSON.parse(
            window.localStorage.getItem("clientPartialDetails_ao") || "{}"
          );
          clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
          clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
          window.localStorage.setItem(
            "clientPartialDetails_ao",
            JSON.stringify(clientPartialDetails_ao)
          );
          dobMatched({});
        }
      }
    }
  };
  function savePanDob(
    applicationIdExists?: boolean,
    skipSavePANDOB?: boolean,
    reqObj?: any
  ) {
    if (
      GlobalStore?.applicationID &&
      GlobalStore.stageStatus.ispersonaldetailscompleted !== true &&
      GlobalStore.stageStatus.isprofiledetailscompleted !== true
    ) {
      AGetCacheData(
        (res: any) => {
          if (
            res &&
            res.data &&
            res?.data?.Result &&
            res?.data?.Result.IsTaggingPresent
          ) {
            let cacheResponse = res?.data?.Result;
            if (
              GlobalStore?.applicationID &&
              GlobalStore.stageStatus.ispersonaldetailscompleted !== true &&
              GlobalStore.stageStatus.isprofiledetailscompleted !== true &&
              cacheResponse !== null &&
              cacheResponse?.IsTaggingPresent
            ) {
              if (cacheResponse?.TaggingMode == "1") {
                cacheKRAFunction(cacheResponse?.Data, skipSavePANDOB, reqObj);
              } else if (cacheResponse?.TaggingMode == "2") {
                GlobalStore.isDigiLocker = true;

                const clientPartialDetails_ao = JSON.parse(
                  window.localStorage.getItem("clientPartialDetails_ao") || "{}"
                );
                clientPartialDetails_ao.PANName =
                  GlobalStore.personaldetails.PANName;
                clientPartialDetails_ao.aadharLinkedChoice =
                  GlobalStore.aadharLinkedChoice;
                clientPartialDetails_ao.applicationId =
                  GlobalStore.applicationID;
                clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
                clientPartialDetails_ao.ckycNo =
                  GlobalStore.stageStatus.ckycnumber;
                clientPartialDetails_ao.clientPrimaryDetailId =
                  GlobalStore.clientPrimaryDetailId;
                clientPartialDetails_ao.dob = GlobalStore.dob;
                clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
                clientPartialDetails_ao.emailID = GlobalStore.user.email;
                clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
                clientPartialDetails_ao.isKRA = GlobalStore.stageStatus.iskra;
                clientPartialDetails_ao.isKYC = GlobalStore.stageStatus.iskyc;

                clientPartialDetails_ao.isSeniorCitizen =
                  window.sessionStorage.getItem("isSeniorCitizen") === "true"
                    ? true
                    : false;
                clientPartialDetails_ao.leadID = GlobalStore.leadId;
                clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
                clientPartialDetails_ao.pan = values.pan;
                clientPartialDetails_ao.panDetails =
                  GlobalStore.personaldetails.panDetails;
                clientPartialDetails_ao.token = GlobalStore.token;
                clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
                clientPartialDetails_ao.signzydt = "";

                window.localStorage.setItem(
                  "clientPartialDetails_ao",
                  JSON.stringify(clientPartialDetails_ao)
                );
                getProfileDetailsFromAadhar(cacheResponse?.Data);
                if (skipSavePANDOB) menuOption();
                // history.push(dashboardUrl.profile);
                navigate(dashboardUrl.profile)
              } else if (cacheResponse?.TaggingMode == "3") {
                GlobalStore.isNormalClient = true;
                GlobalStore.isKYC = false;
                GlobalStore.isKRA = false;
                const clientPartialDetails_ao = JSON.parse(
                  window.localStorage.getItem("clientPartialDetails_ao") || "{}"
                );
                clientPartialDetails_ao.PANName =
                  GlobalStore.personaldetails.PANName;
                clientPartialDetails_ao.aadharLinkedChoice =
                  GlobalStore.aadharLinkedChoice;
                clientPartialDetails_ao.applicationId =
                  GlobalStore.applicationID;
                clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
                clientPartialDetails_ao.ckycNo =
                  GlobalStore.stageStatus.ckycnumber;
                clientPartialDetails_ao.clientPrimaryDetailId =
                  GlobalStore.clientPrimaryDetailId;
                clientPartialDetails_ao.dob = GlobalStore.dob;
                clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
                clientPartialDetails_ao.emailID = GlobalStore.user.email;
                clientPartialDetails_ao.isDigiLocker = GlobalStore.isDigiLocker;
                clientPartialDetails_ao.addressLine1 =
                  cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine1;
                clientPartialDetails_ao.addressLine1 +=
                  cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine2;
                clientPartialDetails_ao.addressLine1 +=
                  cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine3;
                clientPartialDetails_ao.addressLine1 +=
                  cacheResponse?.Data.PermanentAddressDetails.PermanentAddressLine4;
                clientPartialDetails_ao.sameAsPermanent =
                  cacheResponse?.Data.corrsaddraspermanent !== null &&
                    cacheResponse?.Data.corrsaddraspermanent !== undefined
                    ? cacheResponse?.Data.corrsaddraspermanent
                    : true;
                clientPartialDetails_ao.corrAddress =
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine1;
                clientPartialDetails_ao.corrAddress +=
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine2;
                clientPartialDetails_ao.corrAddress +=
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine3;
                clientPartialDetails_ao.corrAddress +=
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondenceAddressLine4;
                GlobalStore.addressLine1 = clientPartialDetails_ao.addressLine1;
                GlobalStore.corrAddress = clientPartialDetails_ao.corrAddress;
                GlobalStore.PinCode =
                  cacheResponse?.Data.PermanentAddressDetails.PermanentPincode;
                GlobalStore.corrPincode =
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondencePincode;
                GlobalStore.sameAsPermanent =
                  cacheResponse?.Data.corrsaddraspermanent !== null &&
                    cacheResponse?.Data.corrsaddraspermanent !== undefined
                    ? cacheResponse?.Data.corrsaddraspermanent
                    : true;
                clientPartialDetails_ao.isSeniorCitizen =
                  window.sessionStorage.getItem("isSeniorCitizen") === "true"
                    ? true
                    : false;
                clientPartialDetails_ao.PinCode =
                  cacheResponse?.Data.PermanentAddressDetails.PermanentPincode;
                clientPartialDetails_ao.corrPincode =
                  cacheResponse?.Data.CorrespondenceAddressDetails.CorrespondencePincode;
                clientPartialDetails_ao.leadID = GlobalStore.leadId;
                clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
                clientPartialDetails_ao.pan = values.pan;
                clientPartialDetails_ao.panDetails =
                  GlobalStore.personaldetails.panDetails;
                clientPartialDetails_ao.token = GlobalStore.token;
                clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
                clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
                clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
                clientPartialDetails_ao.isNormalClient =
                  GlobalStore.isNormalClient;
                window.localStorage.setItem(
                  "clientPartialDetails_ao",
                  JSON.stringify(clientPartialDetails_ao)
                );
                if (skipSavePANDOB) menuOption();
                // history.push(dashboardUrl.profile);
                navigate(dashboardUrl.profile)
              }
            } else {
              originalSavePANDOB(applicationIdExists, skipSavePANDOB, reqObj);
            }

            setCacheResponse(res?.data);
          } else {
            originalSavePANDOB(applicationIdExists, skipSavePANDOB, reqObj);
            setCacheResponse(null);
          }
        },
        {
          uniqueID: GlobalStore?.applicationID,
          key: `AOPDROPOFF-${GlobalStore?.applicationID}`,
        }
      );
    } else {
      originalSavePANDOB(applicationIdExists, skipSavePANDOB, reqObj);
    }

    console.log("panlink log", isPanLinkedToAadhar);
  }

  const kraDobCheckNew = (res: any, applicationIdExists?: boolean) => {
    if (!res || res.error) {
      // setErrCode(1227);
      if (errCode?.includes(res?.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res?.error);
      }
      gtmService({ action: "GetKraDetails", label: "ERROR || ERR108" });
      navigateTo(applicationIdExists);
    } else {
      const responseObj = res.data;

      if (responseObj?.DOB) {
        let dobValue = responseObj.DOB;

        // Check if it's in dd/mm/yyyy format
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dobValue)) {
          const [day, month, year] = dobValue.split("/");
          dobValue = new Date(`${year}-${month}-${day}`);
        }

        if (ageCalculator(dobValue) >= 60) {
          window.sessionStorage.setItem("isSeniorCitizen", "true");
        }
      }

      if (responseObj?.AppErrorDesc?.includes("INVALID DOB")) {
        setIsLoading(false);

        // setErrCode('Date of Birth is not matching with the PAN');
        setErrCode(errCode ? errCode : "" + (res?.error || ""));
        setErrors({ ...errors, dob: errorMsg(errorCode.FE11) });
      } else {
        getKraDetails(responseObj, applicationIdExists);
      }
    }
  };
  const kraDobCheck = (res: any, applicationIdExists?: boolean) => {
    if (!res || res.error) {
      // setErrCode(1227);
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "GetKraDetails", label: "ERROR || ERR108" });
      navigateTo(applicationIdExists);
    } else {
      const responseObj = res.data;
      if (responseObj?.AppErrorDesc?.includes("INVALID DOB")) {
        setIsLoading(false);

        // setErrCode('Date of Birth is not matching with the PAN');
        setErrCode(errCode ? errCode : "" + (res.error || ""));
        setErrors({ ...errors, dob: errorMsg(errorCode.FE11) });
      } else {
        dobMatched(responseObj, applicationIdExists);
      }
    }
  };
  // const kraDobCheckNew = (res: any, applicationIdExists?: boolean) => {
  //   if (!res || res.error) {
  //     // setErrCode(1227);
  //     if (errCode?.includes(res.error)) {
  //       setErrCode(errCode);
  //     } else {
  //       setErrCode(errCode + res.error);
  //     }
  //     gtmService({ action: "GetKraDetails", label: "ERROR || ERR108" });
  //     navigate(applicationIdExists);
  //   } else {
  //     const responseObj = res.data;
  //     if (responseObj.AppErrorDesc?.includes("INVALID DOB")) {
  //       setIsLoading(false);

  //       // setErrCode('Date of Birth is not matching with the PAN');
  //       setErrCode(errCode ? errCode : "" + (res.error || ""));
  //       setErrors({ ...errors, dob: errorMsg(errorCode.FE11) });
  //     } else {
  //       getKraDetails(res, applicationIdExists);
  //       //dobMatched(responseObj, applicationIdExists);
  //     }
  //   }
  // };
  const getProductCode = () => {
    let productCodeNew: string = "";
    if (
      GlobalStore?.user?.accountType !== null &&
      GlobalStore?.user?.accountType !== undefined &&
      GlobalStore?.user?.accountType !== ""
    ) {
      productCodeNew = GlobalStore?.user?.accountType;
    } else {
      const objAccType = window.sessionStorage.getItem("objAccType");
      if (
        localProductCode !== null &&
        localProductCode !== undefined &&
        localProductCode !== "" &&
        localProductCode?.length > 0
      ) {
        productCodeNew = localProductCode;
      } else {
        if (objAccType === "DMT") {
          productCodeNew = "D";
        } else if (objAccType === "RMINV") {
          productCodeNew = "I";
        } else {
          productCodeNew = "TD";
        }
      }
    }

    return productCodeNew;
  };
  const getAccountCategory = () => {
    let accountCategory = null;
    if (getProductCode() == "I") {
      accountCategory = 2;
    } else {
      accountCategory = 1;
    }
    return accountCategory;
  };
  function dobMatched(
    kycobj: any,
    applicationIdExists?: boolean,
    cacheResonse?: boolean
  ) {
    const objUTM_Info = utmDurationInfoObj(startTime, "registrationdur");
    let objAccType = window.sessionStorage.getItem("objAccType") || ""; // only demat getting parameter type
    const objUtm = JSON.parse(
      window.sessionStorage.getItem("objUTM_Info") || "{}"
    );
    const modifiedBy = window.sessionStorage.getItem('empCode')
    const panDobObj = {
      leadId: GlobalStore.leadId,
      emailID: GlobalStore.user.email,
      mobileno: GlobalStore.user.mobile,
      isemployeepan: isEmployee,
      panNo: values.pan || values?.gurdianPanNo,
      dob: GlobalStore.dateofbirth,
      // static data need to remove later
      // aadhaar: "",
      // ispanaadhaarlinked: isPanLinkedToAadhar,
      // relationship: false,
      // relationName: "",
      // others: "",
      // objUTM_Info: objUTM_Info,
      // response: "",
      // TransactionId: "",
      // kycverified: "",
      product: getProductCode(),
      platform: 1,
      panFName: values?.firstName,
      panMName: values?.middleName,
      panLName: values?.lastName,
      PanFSName: values.fatherName,
      SendSelfieLink: togPhoto, //((photoObj.base64==null || photoObj.base64=="") && togPhoto==false) ? true:
      diyReferralLink: localURL,
      accountCategory: getAccountCategory() !== null ? getAccountCategory() : 0,
      createdBy: objAccType === "RMINV" ? objUtm.utm_campaign :
        skipUrlBoolean && !!prodObj?.createdBy && prodObj?.createdBy
          ? parseInt(prodObj?.createdBy)
          : 0,
      rmAssisted: objAccType === "RMINV" ? true :
        skipUrlBoolean && !!prodObj?.createdBy && prodObj?.createdBy
          ? true
          : false,
      entityType: entityType || "",
      entitySubType: entitySubType || "",
      gurdianPanNo: values?.gurdianPanNo,
      gurdianDOB: null,
      gurdianFName: values?.gurdianFName,
      gurdianMName: values?.gurdianMName,
      gurdianLName: values?.gurdianLName,
      accountTypeName: SUBTYPE_MAP[GlobalStore.entitySubType] || null,
      panCompFirmName: values.fullname || "",
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    console.log("called here ===> 2");
    ASavePanDobDetails(
      (res: any) =>
        applicationInitialized(res, kycobj, applicationIdExists, cacheResonse),
      panDobObj
    );
  }
  const isMinor = (dob: any) => {
    const today = new Date();
    const birthDate = new Date(dob); // Parse the DOB
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    // Adjust age if the current date is before the birthday in the current year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      return age - 1 < 18;
    }

    if (age < 18) {
      return true;
    } else {
      return false;
    }
  };
  function applicationInitialized(
    res: any,
    kycobj: any,
    applicationIdExists?: boolean,
    cacheResponse?: boolean
  ) {
    debugger
    console.log("function applicationInitialized : ", kycobj, "||", res);
    if (!res || res.error) {
      console.log("applicationInitialized 00");
      // setErrCode('121 - Error in Application initialization.');
      // setErrCode(errorMessage.applicationInitialized);
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "SavePanDobDetails", label: "ERROR || ERR106" });
      setIsLoading(false);
    } else {
      console.log("applicationInitialized 11");
      if (res.data && res.data.LeadId) {
        GlobalStore.leadId = res.data.LeadId;
        GlobalStore.token = res.data.Token;
        GlobalStore.applicationID = res.data.ApplicationID;
        GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
        GlobalStore.aadharLinkedChoice =
          values.aadharLinked === "Yes" ? true : false;
        GlobalStore.personaldetails.pan = values.pan;
        //  GlobalStore.personaldetails.aadharNo = values.aadhaarNo.slice(-4);
        // Create link for capturing selfie from mobile
        let AccountObj = {
          PanNo: values?.pan,
          AccountCategory: getProductCode() == "I" ? 2 : 1,
          userid: prodObj?.createdBy,
        };
        let accountObjString = JSON.stringify(AccountObj);
        const encodedPan = btoa(accountObjString);
        let stringParams = `selfie?id=${encodedPan}`;

        const selfieUrl = `${config.root}${stringParams}`;
        GlobalStore.selfieUrl = selfieUrl;
        const clientObj = {
          clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
          applicationId: GlobalStore.applicationID,
        };
        window.sessionStorage.setItem(
          "clientDetails",
          JSON.stringify(clientObj)
        );

        //extract pan
        console.log("applicationInitialized 22", GlobalStore);
        if (cacheResponse == true) {
          const clientPartialDetails_ao = JSON.parse(
            window.localStorage.getItem("clientPartialDetails_ao") || "{}"
          );
          clientPartialDetails_ao.clientPrimaryDetailId =
            GlobalStore.clientPrimaryDetailId;
          clientPartialDetails_ao.token = GlobalStore.token;
          clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
          clientPartialDetails_ao.dob = GlobalStore.dob;
          clientPartialDetails_ao.dateOfIncorporation = GlobalStore.dateOfIncorporation;
          clientPartialDetails_ao.birthDate = GlobalStore.birthDate;
          clientPartialDetails_ao.pan = values.pan;
          clientPartialDetails_ao.aadharLinkedChoice =
            GlobalStore.aadharLinkedChoice;
          clientPartialDetails_ao.leadID = GlobalStore.leadId;
          clientPartialDetails_ao.emailID = GlobalStore.user.email;
          clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
          clientPartialDetails_ao.panDetails =
            GlobalStore.personaldetails.panDetails;
          clientPartialDetails_ao.PANName = GlobalStore.personaldetails.PANName;
          clientPartialDetails_ao.isSeniorCitizen =
            window.sessionStorage.getItem("isSeniorCitizen") === "true"
              ? true
              : false;
          clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
          clientPartialDetails_ao.selfieUrl = GlobalStore.selfieUrl;
          clientPartialDetails_ao.isManual = false;
          clientPartialDetails_ao.aadharNo =
            GlobalStore.personaldetails.aadharNo;
          window.localStorage.setItem(
            "aadharNumber",
            GlobalStore.personaldetails.aadharNo
          );
          window.localStorage.setItem(
            "clientPartialDetails_ao",
            JSON.stringify(clientPartialDetails_ao)
          );
          // history.push(dashboardUrl.profile);
          navigate(dashboardUrl.profile)
        } else {
          if (!willDoLater) {
            if (
              isPanLinkedToAadhar &&
              (getProductCode() == "I" || prodObj?.accountCategory == "2")
            ) {
              //   setShowSubmitModal(true);
              // if (applicationModeType !== "isKRA") {
              //   setApplicationModeType("isKRA");
              // }

              let filterLeftBar = leftNavBarArray;
              let filterNavIndexForProfiler = leftNavBarArray?.findIndex(
                (filter) => filter?.navUrl == dashboardUrl.profiler
              );
              if (filterNavIndexForProfiler > 0)
                filterLeftBar?.splice(filterNavIndexForProfiler, 1);
              let filterNavIndex = filterLeftBar?.findIndex(
                (filter) => filter?.navUrl == "/plan"
              );
              if (filterNavIndex > 0) filterLeftBar?.splice(filterNavIndex, 1);

              if (!filterLeftBar?.includes(dematNavBarObj))
                filterLeftBar.push(dematNavBarObj);
              GlobalStore.leftNavBarState = filterLeftBar;
            }
            let panOCRval = panOCR;
            panOCRval.PayloadObj.applicationid = GlobalStore.applicationID;
            setPanOCR(panOCRval);
            uploadPanFile(panOCR.val, panOCR.fileName, panOCR.id, panOCR.type);
            // AextractPan(
            //   (res: any) =>
            //     storeOcrData(
            //       res,
            //       panOCR.val,
            //       panOCR.fileName,
            //       panOCR.id,
            //       panOCR.type
            //     ),
            //   panOCR.PayloadObj
            // );
          } else {
            if (
              skipUrlBoolean &&
              prodObj?.createdBy !== null &&
              prodObj?.createdBy !== undefined
            ) {
              if (isPanLinkedToAadhar !== true) {
                let filterLeftBar = leftNavBarArray;
                let filterNavIndexForProfiler = leftNavBarArray?.findIndex(
                  (filter) => filter?.navUrl == dashboardUrl.profiler
                );
                if (filterNavIndexForProfiler > 0)
                  filterLeftBar?.splice(filterNavIndexForProfiler, 1);
                let filterNavIndex = filterLeftBar?.findIndex(
                  (filter) => filter?.navUrl == "/plan"
                );
                if (filterNavIndex > 0)
                  filterLeftBar?.splice(filterNavIndex, 1);
                let filterNavIndex2 = filterLeftBar?.findIndex(
                  (filter) => filter?.navUrl == dashboardUrl.eSign
                );
                if (filterNavIndex > 0)
                  filterLeftBar?.splice(filterNavIndex2, 1);
                let filterNavIndex3 = filterLeftBar?.findIndex(
                  (filter) => filter?.navUrl == dashboardUrl.profiler
                );
                if (filterNavIndex > 0)
                  filterLeftBar?.splice(filterNavIndex3, 1);
                let filterNavIndex4 = filterLeftBar?.findIndex(
                  (filter) => filter?.navUrl == dashboardUrl.ipv
                );
                if (filterNavIndex4 > 0)
                  filterLeftBar?.splice(filterNavIndex4, 1);
                if (!filterLeftBar?.includes(dematNavBarObj))
                  filterLeftBar.push(dematNavBarObj);
                GlobalStore.leftNavBarState = filterLeftBar;
              } else {
                //  setShowSubmitModal(true);
                setDobChecked(true);
                // if (applicationModeType !== "isKRA") {
                //   setApplicationModeType("isKRA");
                // }
                let filterLeftBar = leftNavBarArray;
                let filterNavIndex = filterLeftBar?.findIndex(
                  (filter) => filter?.navUrl == "/plan"
                );
                if (filterNavIndex > 0)
                  filterLeftBar?.splice(filterNavIndex, 1);
                let filterNavIndex2 = filterLeftBar?.findIndex(
                  (filter) => filter?.navUrl == dashboardUrl.eSign
                );
                if (filterNavIndex > 0)
                  filterLeftBar?.splice(filterNavIndex2, 1);
                let filterNavIndex3 = filterLeftBar?.findIndex(
                  (filter) => filter?.navUrl == dashboardUrl.profiler
                );
                if (filterNavIndex > 0)
                  filterLeftBar?.splice(filterNavIndex3, 1);
                let filterNavIndex4 = filterLeftBar?.findIndex(
                  (filter) => filter?.navUrl == dashboardUrl.ipv
                );
                if (filterNavIndex4 > 0)
                  filterLeftBar?.splice(filterNavIndex4, 1);
                if (!filterLeftBar?.includes(dematNavBarObj))
                  filterLeftBar.push(dematNavBarObj);
                GlobalStore.leftNavBarState = filterLeftBar;
              }
            }
          }

          const clientPartialDetails_ao = {
            clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
            token: GlobalStore.token,
            applicationId: GlobalStore.applicationID,
            dob: GlobalStore.dob,
            dateOfIncorporation: GlobalStore.dateOfIncorporation,
            birthDate: GlobalStore.birthDate,
            pan: values.pan,
            aadharLinkedChoice: GlobalStore.aadharLinkedChoice,
            leadID: GlobalStore.leadId,
            emailID: GlobalStore.user.email,
            mobile: GlobalStore.user.mobile,
            panDetails: GlobalStore.personaldetails.panDetails,
            PANName: GlobalStore.personaldetails.PANName,
            isSeniorCitizen:
              window.sessionStorage.getItem("isSeniorCitizen") === "true"
                ? true
                : false,
            isDigiLocker: GlobalStore.isDigiLocker,
            isKRA: false,
            isKYC: false,
            isSeeding: GlobalStore.isSeeding,
            selfieUrl: GlobalStore.selfieUrl,
            isManual: false,
            aadharNo: GlobalStore.personaldetails.aadharNo,
            fsfullName: values?.fatherName,
          };
          window.localStorage.setItem(
            "aadharNumber",
            GlobalStore.personaldetails.aadharNo
          );
          window.localStorage.setItem(
            "clientPartialDetails_ao",
            JSON.stringify(clientPartialDetails_ao)
          );

          nextprocess(kycobj);
        }
      } else {
        // setErrCode('120 - Error in Application initialization.');
        if (errCode?.includes(res?.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res?.error);
        }
        setIsLoading(false);
      }
    }
    //setApplicationInitializedFlag(true);
  }

  React.useEffect(() => {
    if (applicationInitializedFlag && applicationModeType === "isDigiLocker" && (!(objAccType === 'RMINV' && !GlobalStore.isKRA))) {
      setShowSubmitModal(true);
    }
  }, [applicationInitializedFlag, applicationModeType]);

  function checkPendingUpload(res: any) {
    if (!res || res?.error) {
      // setErrCode('1221 - Error in fetching pending document upload list.');
      //   setErrCode(errorMessage.checkPendingUpload);
      if (errCode?.includes(res?.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res?.error);
      }
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR112" });
      setIsLoading(false);
    } else {
      if (res && res?.data == null) {
        let isUploadDocumentsCompleted: boolean = false;
        AGetStageCompletionStatus(
          (res: any) => getClientStageDetails(res, isUploadDocumentsCompleted),
          GlobalStore.applicationID
        );
      } else if (res && res.data !== null) {
        const list: Array<any> = JSON.parse(res.data).filter(
          (item: any) =>
            // Prev api response
            // item.documentcategoryid !== 36 &&
            // item.documentcategoryid !== 30 &&
            // item.documentcategoryid !== 62

            // Current Api response
            item.Mandatory == true
        );
        let isUploadDocumentsCompleted: boolean = false;
        if (list.length === 0 || list[0].count === 0)
          isUploadDocumentsCompleted = true;
        const redisReqObj = {
          applicationId: GlobalStore.applicationID,
          clientPrimaryDetailsId: GlobalStore.clientPrimaryDetailId,
        };
        // ARedisDigilockerDoc(
        //   (res: any) => getRedisData(res, isUploadDocumentsCompleted),
        //   redisReqObj
        // );
        AGetStageCompletionStatus(
          (res: any) => getClientStageDetails(res, isUploadDocumentsCompleted),
          GlobalStore.applicationID
        );
      } else {
        // setErrCode('1222 - Error in fetching pending document upload list.');
        if (errCode?.includes(res?.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res?.error);
        }
        setIsLoading(false);
      }
    }
  }

  function getClientStageDetails(
    res: any,
    isUploadDocumentsCompleted: boolean
  ) {
    if (!res || res.error) {
      // setErrCode('1061 - Error in fetching stage completion details.');
      // setErrCode(errorMessage.getClientStageDetails);
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({
        action: "GetStageCompletionStatus",
        label: "ERROR || ERR113",
      });
      setIsLoading(false);
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        GlobalStore.entityType = responseObj?.entitytype
        GlobalStore.entitySubType = responseObj?.entitysubtype
        //set stage api data to GlobalStore
        setStageData(responseObj);
        let cacheData = null;
        //check completeness of stages
        checkModuleCompleteness(isUploadDocumentsCompleted);
        setCheckpanaaddharflag(responseObj.checkpanaaddharflag);
        setStageBooleanFlags((stageBooleanFlags) => {
          stageBooleanFlags.isPersonalStage =
            responseObj?.ispersonaldetailscompleted;
          stageBooleanFlags.isProfileStage =
            responseObj?.isprofiledetailscompleted;
          return stageBooleanFlags;
        });
        if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy !== undefined
        ) {
          if (
            !(
              responseObj.isprofiledetailscompleted &&
              responseObj.ispersonaldetailscompleted
            )
          )
            GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        } else {
          if (responseObj.isdigilockercompleted) {
            GlobalStore.isDigiLocker = true;
            console.log("setApplicationModeType 2");
            setApplicationModeType("isDigiLocker");
          }
        }

        if (responseObj.iskra) {
          GlobalStore.isKRA = true;
          console.log("setApplicationModeType 3");
          setApplicationModeType("isKRA");
        }
        if (responseObj.iskyc) GlobalStore.isKYC = true;
        //route according to stage api response
        // if (
        //     !responseObj.isdigilockercompleted &&
        //     values.aadharLinked === 'Yes' &&
        //     !GlobalStore.isDigiLocker &&
        //     !responseObj.ispersonaldetailscompleted
        // )
        //     GlobalStore.nextIncompleteStage = containerUrl.dgLocker;
        if (
          !(
            responseObj.isprofiledetailscompleted &&
            responseObj.ispersonaldetailscompleted
          )
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        else if (!responseObj.isbankdetailscompleted) {
          GlobalStore.nextIncompleteStage = dashboardUrl.bank;
        } else if (
          responseObj?.accountcategory === 2 &&
          !responseObj?.isdpcompleted
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.demat;
        else if (
          responseObj?.accountcategory !== 2 &&
          (!responseObj.isbrokeragesegmentcompleted ||
            !responseObj.isbrokerageschemecompleted)
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.plan;
        else if (!isUploadDocumentsCompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.doc;
        else if (
          !GlobalStore.isDigiLocker &&
          !GlobalStore.isKRA &&
          !GlobalStore.isKYC &&
          !responseObj.isipvarificationcompleted
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.ipv;
        else if (responseObj.isagentvisitcompleted)
          GlobalStore.nextIncompleteStage = containerUrl.ocv;
        else if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy !== undefined &&
          !responseObj.isesigncompleted &&
          responseObj?.accountcategory === 2
        ) {
          if (responseObj.bpm_pd_status === 0)
            // history.push(statusUrl.docVerificationInProgress);
            navigate(statusUrl.docVerificationInProgress)
          else if (responseObj.bpm_pd_status === 1)
            // history.push(containerUrl.poa);
            navigate(containerUrl.poa)
        } else if (!responseObj.isesigncompleted)
          GlobalStore.nextIncompleteStage = dashboardUrl.eSign;
        else if (responseObj.bpm_pd_status === 0)
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress)
        else if (responseObj.bpm_pd_status === 1)
          // history.push(containerUrl.poa);
          navigate(containerUrl.poa)
        if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy !== undefined &&
          !responseObj.isesigncompleted &&
          responseObj?.accountcategory === 2
        ) {
          if (responseObj.bpm_pd_status === 0)
            // history.push(statusUrl.docVerificationInProgress);
            navigate(statusUrl.docVerificationInProgress)
        } else {
          savePanDob(true);
        }
      } else {
        // setErrCode('1062 - Error in fetching stage completion details.');
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setIsLoading(false);
      }
    }
  }

  const getUploadKraResponse = (
    res: any,
    uploadObj: saveDocumentObj,
    applicationIdExists?: boolean
  ) => {
    if (!res || res.error) {
      setErrCode(res.error);
      // setErrCode("1361- Error in uploading the file.");
      gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR114-6" });
      setIsLoading(false);
    } else {
      if (res.data && res.data.Result == true) {
        uploadObj.fileName = res.data.Guid;
        kraDocCount += 1;
      } else {
        // setErrCode('1361- Error in uploading the file.');
        setErrCode(errorMessage.getUploadResponse);
      }
    }
    saveKraDetails.push(uploadObj);
    const saveobjUTM_Info = utmDurationInfoObj(startTime, "panInfoDuration");
    const objUTM_Info = utmDurationInfoObj(startTime, "registrationdur");
    const modifiedBy = window.sessionStorage.getItem('empCode')
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: saveKraDetails,
      leadId: GlobalStore.leadId,
      objUTM_Info: objUTM_Info,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };

    if (kraDocs === kraDocCount) {
      ASaveDocumentDetails(
        (res: any) =>
          kraDocumentDetailsSaved(res, applicationIdExists, uploadObj),
        saveObj
      );
    }
  };
  const kraDocumentDetailsSaved = (
    res: any,
    applicationIdExists?: boolean,
    uploadObj?: saveDocumentObj
  ) => {
    console.log("SaveUploadedDocumentDetails", kraDocs, kraDocCount);

    if (!res || res.error) {
      // setErrCode('1641- Error in saving document details of the application.');
      // setErrCode(errorMessage.documentDetailsSaved);
      setErrCode(res.error);
      gtmService({
        action: "SaveUploadedDocumentDetails",
        label: "ERROR || ERR114-5",
      });
      setIsLoading(false);
    } else {
      setDocumentInfo((prev) => {
        console.log(
          "prev.totalDocs",
          prev.totalDocs,
          uploadObj?.fileName,
          prev.totalDocs.filter((x) => x != uploadObj?.fileName)
        );
        return {
          ...prev,
          uploadedDocsCount: prev.uploadedDocsCount + 1,
          totalDocs: prev.totalDocs.filter((x) => x !== uploadObj?.fileName),
        };
      });
      if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
        setShowSubmitModal(true);
      }
      // setIsLoading(false);
      // setShowSubmitModal(true);
    }
  };

  function getKraDetails(res: any, applicationIdExists?: boolean) {
    console.log("KRA console", res);
    if (!res || res.error) {
      // setErrCode('1227- Error in fetching details from KRA portal.');
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "GetKraDetails", label: "ERROR || ERR108-1" });
      navigateTo(applicationIdExists);
    } else {
      const responseObj = res.data ? res.data : res;
      if (
        responseObj &&
        responseObj.AppStatus === "07"
        // !responseObj.ErrorCode &&
        // responseObj.AppStatus === "07" //responseObj.AppStatus === "02" ||
      ) {
        GlobalStore.isKRA = true;
        if (applicationModeType !== "isKRA") {
          setApplicationModeType("isKRA");
        }
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );

        GlobalStore.KRA_email = responseObj.KraEmail
          ? responseObj.KraEmail
          : "";
        GlobalStore.KRA_mobile = responseObj.KraMobile
          ? responseObj.KraMobile
          : "";
        GlobalStore.KRA_mode = responseObj.kra_mode ? responseObj.kra_mode : 0;
        if (getAccountCategory() == 2) {
          if (
            skipUrlBoolean &&
            prodObj?.createdBy !== null &&
            prodObj?.createdBy !== undefined
          ) {
          } else {
            let filterLeftBar = leftNavBarArray;
            let filterNavIndex1 = filterLeftBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.eSign
            );
            if (filterNavIndex1 > 0) filterLeftBar?.splice(filterNavIndex1, 1);
            if (!filterLeftBar?.includes(authenticateNavBarObj))
              filterLeftBar.push(authenticateNavBarObj);
            GlobalStore.leftNavBarState = filterLeftBar;
          }
        }

        // if (!GlobalStore.isKYC) {
        const resultObj = responseObj;
        GlobalStore.kraInfoObject.addressLine1 = `${resultObj.AppPerAdd1} ${resultObj.AppPerAdd2 || ""
          } ${resultObj.AppPerAdd3 || ""}`;
        GlobalStore.kraInfoObject.addressLine1 =
          GlobalStore.kraInfoObject.addressLine1; //.replace(/[^a-zA-Z0-9 ]/g, " ")

        GlobalStore.kraInfoObject.corrAddress = `${resultObj.AppCorAdd1} ${resultObj.AppCorAdd2 || ""
          } ${resultObj.AppCorAdd3 || ""}`;
        GlobalStore.kraInfoObject.corrAddress =
          GlobalStore.kraInfoObject.corrAddress; //.replace(/[^a-zA-Z0-9 ]/g, " ")
        GlobalStore.kraInfoObject.pincode = resultObj.AppPerPincd;
        GlobalStore.kraInfoObject.corrPincode = resultObj.AppCorPincd;
        GlobalStore.personaldetails.fsfullName = resultObj.FatherName
          ? resultObj.FatherName
          : GlobalStore.personaldetails.fsfullName;
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.gender = responseObj?.Gender;
        GlobalStore.personaldetails.gender = responseObj?.Gender;
        clientPartialDetails_ao.addressLine1 =
          GlobalStore.kraInfoObject.addressLine1;
        clientPartialDetails_ao.pincode = GlobalStore.kraInfoObject.pincode;
        clientPartialDetails_ao.corrAddress =
          GlobalStore.kraInfoObject.corrAddress;
        clientPartialDetails_ao.corrPincode =
          GlobalStore.kraInfoObject.corrPincode;
        clientPartialDetails_ao.fsfullName =
          GlobalStore.personaldetails.fsfullName;
        clientPartialDetails_ao.sameAsPermanent =
          GlobalStore.kraInfoObject.addressLine1 ==
            GlobalStore.kraInfoObject.corrAddress
            ? true
            : false;
        // } else {
        //     clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        // }

        //getKraDocumentUpload(responseObj);
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        registerCleverTapEventAfterProceed();
        gtmService({ action: "PAN_DOB", label: "Step_Complete" });
        if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
          setShowSubmitModal(true);
        }
        if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy !== undefined
        ) {
          setDocumentInfo({
            totalDocs: [],
            totalDocsCount: 0,
            uploadedDocsCount: 0,
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
        } //  if (applicationIdExists) history.push(GlobalStore.nextIncompleteStage);
        // else {
        //   // history.push(dashboardUrl.profile);
        //   // setIsLoading(false);
        //   setShowSubmitModal(true);
        // }
      } else {
        if (!GlobalStore.isKRA) {
          console.log("setApplicationModeType 5");
          if (
            skipUrlBoolean &&
            prodObj?.createdBy !== null &&
            prodObj?.createdBy !== undefined
          ) {
            setIsNormalClient(true);
            if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
              setShowSubmitModal(true);
            }
            GlobalStore.isNormalClient = true;
            const clientPartialDetails_ao = JSON.parse(
              window.localStorage.getItem("clientPartialDetails_ao") || "{}"
            );
            clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
            window.localStorage.setItem(
              "clientPartialDetails_ao",
              JSON.stringify(clientPartialDetails_ao)
            );
            setIsLoading(false);
            // history.push(dashboardUrl?.personalIfo);
            navigate(dashboardUrl?.personalIfo)
          } else {
            setApplicationModeType("isDigiLocker");

            setIsNormalClient(true);
            GlobalStore.isNormalClient = true;
            const clientPartialDetails_ao = JSON.parse(
              window.localStorage.getItem("clientPartialDetails_ao") || "{}"
            );
            clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
            window.localStorage.setItem(
              "clientPartialDetails_ao",
              JSON.stringify(clientPartialDetails_ao)
            );
            setIsLoading(false);
            navigateTo(applicationIdExists);
          }
        } else navigateTo(applicationIdExists);
      }
    }
  }

  const checkPanValidationMsgs = (response: any) => {
    let result = "";
    Object.keys(panValidationKeyList).forEach((x) => {
      if (response[x] === "N") {
        // console.log(data[panValidationKeyList[x]])
        result = result + "\n" + response[panValidationKeyList[x]];
      }
    });
    return result;
  };

  const panValidationCallback = (res: any, callBackFunction: Function) => {
    if (!res || res.error) {
      if (panInvalidMsg?.includes(res.error)) {
        setPanInvalidMsg(panInvalidMsg);
      } else {
        setPanInvalidMsg(panInvalidMsg + res.error);
      }
      setIsLoading(false);
    } else {
      /*
        new api added for a pan api check
      */
      if (res && res.data) {
        panValidationResp = res.data;
        if (
          res &&
          res.data &&
          (res.data?.Dob === "N" ||
            res.data?.Name === "N" ||
            res.data?.PanStatus === "N" ||
            res.data?.SeedingStatus === "N")
        ) {
          setErrorFoundInPanValidation(false);
          setPanInvalidMsg(checkPanValidationMsgs(res.data));
        }
        if (res?.data?.SeedingStatus === "Y") {
          isPanLinkedToAadhar = true;
        } else {
          isPanLinkedToAadhar = false;
        }
        if (
          (res && res.data && res.data?.Dob === "N") ||
          res.data?.Name === "N" ||
          res.data?.PanStatus === "N" ||
          res.data?.SeedingStatus === "N"
        ) {
          setIsLoading(false);
        } else {
          setErrorFoundInPanValidation(true);
          //     console.log("values.dob===extractPanResponse?.date_of_birth",values.dob===extractPanResponse?.date_of_birth,values,extractPanResponse)
          if (
            values.pan === extractPanResponse?.id_number &&
            moment(values.dob).format("YYYY-MM-DD") ===
            extractPanResponse?.date_of_birth
          ) {
            setDobChecked(true);
          } else {
            if (cibilEmailFound) {
              setDobChecked(true);
            } else setDobChecked(false);
          }

          validatePANNew(
            res?.data?.SeedingStatus,
            res?.data?.SeedingStatusMsg,
            res?.data?.PanStatus
          );
        }
      }
    }
  };
  const panValidation = (
    panObject: {
      panNo: string;
      name: string;
      dob: string;
      source: string;
    },
    callBackFunction: Function
  ) => {
    APanVerification((res: any) => {
      panValidationCallback(res, callBackFunction);
    }, panObject);
  };
  function navigateTo(applicationIdExists: boolean | undefined, reqObj?: any) {
    registerCleverTapEventAfterProceed();
    gtmService({ action: "PAN_DOB", label: "Step_Complete" });
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    console.log(
      "ckyc,kra-values-",
      clientPartialDetails_ao.ckycNo,
      "||",
      clientPartialDetails_ao.isKRA
    );
    console.log("showSubmitModal", showSubmitModal);
    if (showSubmitModal) {
      if (
        !clientPartialDetails_ao.ckycNo ||
        clientPartialDetails_ao.ckycNo === "" ||
        !clientPartialDetails_ao.isKRA
      ) {
        console.log("oabove ddglocker");
        if (
          skipUrlBoolean &&
          prodObj?.createdBy !== null &&
          prodObj?.createdBy != undefined
        ) {
          // history.push(dashboardUrl.profile);
          navigate(dashboardUrl.profile)
        } else {
          // history.push(containerUrl.dgLocker);
          navigate(containerUrl.dgLocker)
        }
      } else if (applicationIdExists) {
        console.log("oabove ddglocker 1");
        // history.push(GlobalStore.nextIncompleteStage);
        navigate(GlobalStore.nextIncompleteStage)
      }
      // else if (values.aadharLinked !== 'No') history.push(containerUrl.dgLocker);
      else {
        console.log("oabove ddglocker 2");
        if (!errCode && errCode.length === 0)
          navigate(dashboardUrl.profile)
      }
    }
    if (
      (skipUrlBoolean &&
        prodObj?.createdBy !== null &&
        prodObj?.createdBy != undefined &&
        applicationIdExists) || ((objAccType === 'RMINV' && !GlobalStore.isKRA))
    ) {
      if ((objAccType === 'RMINV' && !GlobalStore.isKRA)) {
        GlobalStore.nextIncompleteStage = dashboardUrl.personalIfo
        // history.push(dashboardUrl.personalIfo);
        navigate(dashboardUrl.personalIfo)
      }
      // history.push(GlobalStore.nextIncompleteStage);
      navigate(GlobalStore.nextIncompleteStage)
    }
    if (
      reqObj !== null &&
      reqObj !== undefined &&
      reqObj?.skipUrlBoolean &&
      reqObj?.rmid !== null &&
      reqObj?.rmid != undefined &&
      applicationIdExists
    ) {
      // history.push(GlobalStore.nextIncompleteStage);
      navigate(GlobalStore.nextIncompleteStage)
    }
    if (!showSubmitModal) {
      if (!(objAccType === 'RMINV' && !GlobalStore.isKRA)) {
        setShowSubmitModal(true);
      }
      setIsLoading(false);
    }
  }

  // This function reads the browsed file and returns the base64 string and other details
  function onPanDocUploadComplete(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setPanFileUploadedLoader(true);
    setIsLoading(true);
    panObj.imgUrl = "";
    panObj.documentId = 1;
    panObj.documentCategoryId = "2";
    panObj.uploadPer = 100;
    setPanObj(panObj);
    setErrCode("");
    setErrorFoundInPanValidation(false);
    const panOCR = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      documentcategory: "PAN Card",
      documentid: panObj.documentId,
      source: DIY,
    };

    setPanOCR({
      PayloadObj: panOCR,
      val: val,
      fileName: fileName,
      id: id,
      type: type,
    });

    AextractPanNew((res: any) => {
      if (!res || res.error) {
        setIsLoading(false);
        // setErrCode('Invalid Image');
        // setErrCode(errorMessage.imgNotMatchWithPan);
        if (errCode?.includes(res.error)) {
          setErrCode(errCode);
        } else {
          setErrCode(errCode + res.error);
        }
        setPanFileUploaded(true);
        setPanFileUploadedLoader(false);
        // alert('Pan Card number entered and the uploaded image do not match. Please upload correct PAN');
      } else {
        if (res?.data?.error && res?.data?.error !== "INVALID_PDF") {
          setErrCode(errCode + res?.data?.error);
          setPanFileUploaded(true);
          setPanFileUploadedLoader(false);
        } else {
          if (res && res?.data?.result) {
            setExtractPanResponse(res?.data?.result?.extraction_output);
            if (
              res?.data?.result?.extraction_output?.id_number === "" ||
              res?.data?.result?.extraction_output?.id_number === null ||
              res?.data?.result?.extraction_output?.id_number === undefined
            ) {
              setInvalidPanFileUploadedMsg(
                "Oops!! You seem to have uploaded the wrong document. Please upload Pan Card!!"
              );
              setPanFileUploaded(false);
              setPanFileUploadedLoader(false);
            } else {
              setInvalidPanFileUploadedMsg("");
            }
            setValues((values) => {
              values.pan = res?.data?.result?.extraction_output?.id_number;
              values.dob = new Date(
                res?.data?.result?.extraction_output?.date_of_birth
              );
              if (res?.data?.result?.extraction_output?.name_on_card !== null) {
                let fullName =
                  res?.data?.result?.extraction_output?.name_on_card?.split(
                    " "
                  );
                values.firstName =
                  fullName?.length > 0 ? fullName[0] ?? "" : "";
                values.lastName =
                  fullName?.length > 0
                    ? fullName[fullName?.length - 1] ?? ""
                    : "";
                console.log("splice", fullName);
                fullName.splice(0, 1);
                fullName.splice(fullName?.length - 1);
                values.middleName = fullName.join(" ");
                values.fatherName =
                  res?.data?.result?.extraction_output?.fathers_name;
              }

              return values;
            });

            GlobalStore.personaldetails.fsfullName =
              res?.data?.result?.extraction_output?.fathers_name;
            const clientPartialDetails_ao = JSON.parse(
              window.localStorage.getItem("clientPartialDetails_ao") || "{}"
            );
            clientPartialDetails_ao.fsfullName =
              GlobalStore.personaldetails.fsfullName;
            window.localStorage.setItem(
              "clientPartialDetails_ao",
              JSON.stringify(clientPartialDetails_ao)
            );
            setPanFileUploadedLoader(false);
            if (
              val !== null &&
              val !== undefined &&
              fileName?.length > 0 &&
              id?.length > 0
            ) {
              setPanFileUploaded(true);
            } else {
              setPanFileUploaded(false);
            }
          } else {
            setPanFileUploaded(true);
            setPanFileUploadedLoader(false);
          }
        }
      }
    }, panOCR);
    setIsLoading(false);
  }
  const uploadPanFile = (
    val: any,
    fileName: string,
    id: string,
    type: string
  ) => {
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      filename: fileName,
      panNo: values?.pan,
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    const savePanObj: saveDocumentObj = {
      documentCategoryId: panObj.documentCategoryId?.toString(),
      documentId: panObj.documentId?.toString(),
      fileName:
        panObj.fileName + (type === "application/pdf" ? ".pdf" : ".jpg"),
      isfilecropped: false,
      mimeType: type,
      panno: GlobalStore.personaldetails.pan,
      personaldetailsid: "0",
      autoqc: false,
      iskycdocument: false,
    };
    let PanUploadObject = {
      savePanObj: savePanObj,
      uploadObj: uploadObj,
      id: id,
      fileName: fileName,
      type: type,
    };

    const saveobjUTM_Info = utmDurationInfoObj(startTime, "panInfoDuration");
    const objUTM_Info = utmDurationInfoObj(startTime, "registrationdur");

    setPanUploadObject(PanUploadObject);
    GlobalStore.panOCRObj = extractPanResponse;
    if (checkAutoQcForPan()) {
      savePanObj.autoqc = true;
    } else {
      savePanObj.autoqc = false;
    }
    saveDetails.push(savePanObj);
    setDocumentInfo((prev: any) => {
      return {
        ...prev,
        totalDocsCount: prev.totalDocsCount + 1,
        totalDocs: !prev.totalDocs.includes(savePanObj.fileName)
          ? [...prev.totalDocs, savePanObj.fileName]
          : [...prev.totalDocs],
      };
    });
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: saveDetails,
      leadId: GlobalStore.leadId,
      objUTM_Info: objUTM_Info,
    };
    AUploadDocument(
      (res: any) => getPanUploadRes(res, savePanObj),
      uploadObj,
      (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
      saveObj
    );
  };

  // This function takes care of waiting till the uploading of file is completed b4 getPanUploadRes fn is called
  const onUploadProgress = (
    event: ProgressEvent,
    id: string,
    fileName: string,
    type: string
  ) => {
    const { loaded, total } = event;
    let percentage = Math.floor((loaded * 100) / total);
    let panCopy = { ...panObj };
    if (percentage < 100) {
      panCopy.id = id;
      panCopy.disable = false;
      panCopy.uploadPer = percentage;
      panCopy.hideProgress = true;
      panCopy.showFile = false;
      setPanObj(panCopy);
    } else if (percentage === 100) {
      panCopy.id = id;
      panCopy.disable = false;
      panCopy.uploadPer = percentage;
      panCopy.showFile = false;
      panCopy.hideProgress = false;
      panCopy.fileName = fileName;
      panCopy.mimeType = type;
      setPanObj(panCopy);
    }
  };

  // This fn is called after uploading of file is completed
  const getPanUploadRes = (res: any, savePanObj: saveDocumentObj) => {
    if (!res || res.error) {
      // setErrCode('1361- Error in uploading the file.');
      // setErrCode(errorMessage.getUploadResponse);
      if (errCode?.includes(res.error)) {
        setErrCode(errCode);
      } else {
        setErrCode(errCode + res.error);
      }
      gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR114-8" });
      setIsLoading(false);
      setPanUploaded(false);
      setShowSubmitModal(false);
    } else {
      if (res.data && res.data.Result) {
        savePanObj.fileName = res.data.Guid;
      }
      GlobalStore.isPANVerified = true;
      setPanUploaded(true);
      const clientPartialDetails_ao = JSON.parse(
        window.localStorage.getItem("clientPartialDetails_ao") || "{}"
      );
      clientPartialDetails_ao.isPANVerified = GlobalStore.isPANVerified;
      window.localStorage.setItem(
        "clientPartialDetails_ao",
        JSON.stringify(clientPartialDetails_ao)
      );

      //setIsLoading(false);

      if (isPanLinkedToAadhar !== true) {
        setApplicationInitializedFlag(true);
      }
      setDocumentInfo((prev: any) => {
        console.log(
          "prev.totalDocs",
          prev.totalDocs,
          savePanObj.fileName,
          prev.totalDocs.filter((x: string) => x != savePanObj.fileName)
        );
        return {
          ...prev,
          uploadedDocsCount: prev.uploadedDocsCount + 1,
          totalDocs: prev.totalDocs.filter(
            (x: string) => x != savePanObj.fileName
          ),
        };
      });
      // ASaveDocumentDetails((res: any) => {
      //   if (!res || res.error) {
      //     if (errCode?.includes(res.error)) {
      //       setErrCode(errCode);
      //     } else {
      //       setErrCode(errCode + res.error);
      //     }
      //     if (isPanLinkedToAadhar !== true) {
      //       setApplicationInitializedFlag(true);
      //     }
      //   } else {
      //     if (res && res.data) {
      //       if (isPanLinkedToAadhar !== true) {
      //         setApplicationInitializedFlag(true);
      //       }
      //       setDocumentInfo((prev: any) => {
      //         console.log(
      //           "prev.totalDocs",
      //           prev.totalDocs,
      //           savePanObj.fileName,
      //           prev.totalDocs.filter((x: string) => x != savePanObj.fileName)
      //         );
      //         return {
      //           ...prev,
      //           uploadedDocsCount: prev.uploadedDocsCount + 1,
      //           totalDocs: prev.totalDocs.filter(
      //             (x: string) => x != savePanObj.fileName
      //           ),
      //         };
      //       });
      //     }
      //   }
      // }, saveObj);
    }
  };

  const handleContinue = () => {
    setErrCode("");
    if (!GlobalStore.leadId || GlobalStore.leadId === "") navigateTo(false);
    console.log(
      " Object.values(errors).some((error) => error)",
      Object.values(errors).some((error) => error)
    );
  };

  console.log(
    "isNormalClient =",
    isNormalClient,
    "|| panNumberMatched =",
    panNumberMatched,
    "|| dobChecked=,",
    dobChecked,
    "|| removePanImg=",
    removePanImg
  );

  const handleRemove = () => {
    setPanFileUploaded(false);
    setPanFileUploadedLoader(false);
    setPanInvalidMsg("");
    setInvalidPanFileUploadedMsg("");
    setPanOCR(null);
    setErrors({
      pan: undefined,
      dob: undefined,
      aadharLinked: undefined,
      aadhaarNo: undefined,
      firstName: undefined,
      middleName: undefined,
      lastName: undefined,
    });
  };

  React.useEffect(() => {
    if (submitFlag && errCode == "") {
      handleSubmit();
    }
  }, [submitFlag, errCode]);

  const clear_Error = () => {
    setErrCode("");
    setSubmitFlag(true);
  };

  // disabled={
  //   Object.values(errors).some((error) => error) ||
  //   Object.values(values).some((value) => !value) ||
  //   (isNormalClient &&
  //     (!panNumberMatched || !dobChecked || removePanImg)) ||
  //   !consent ||
  //   !panOCR
  // }

  function nextprocess(kycobj: any) {
    //  updateUtmInfo(() => {});

    if (false) {
      //togPhoto
      const smsBody = {
        mobNo: GlobalStore.user.mobile,
        // selfieLinkText: `Give a Smile and complete your Selfie process for Online Account Opening, click here ${selfieUrl} to complete the process. Regards, Nuvama`,
        //selfieLinkText: selfieUrl,
        selfieLinkText: GlobalStore.selfieUrl,
      };
      ASendSms((res: any) => {
        if (!res || res.error) {
          setErrCode(errCode + res.error);
        } else {
          if (res && res.data) {
          }
        }
      }, smsBody);
    }
    if (
      isPanLinkedToAadhar !== null &&
      isPanLinkedToAadhar !== undefined &&
      isPanLinkedToAadhar == true
    ) {
      setIsLoading(true);
      const reqObj = {
        dbo: `${moment(values.dob).format("DD/MM/YYYY")}`,
        panno: values.pan || values.gurdianPanNo,
        applicationId: GlobalStore.applicationID,
        clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
        // documentInfo: saveDetails,
        leadId: GlobalStore.leadId,
        CreatedBy:
          skipUrlBoolean && !!prodObj?.createdBy && prodObj?.createdBy
            ? parseInt(prodObj?.createdBy)
            : 0,
      };
      AGetKraDetails(
        (res: any) =>
          kraDobCheckNew(
            res,
            GlobalStore?.applicationID !== null &&
              GlobalStore?.applicationID !== undefined
              ? true
              : false
          ),
        reqObj
      );
    } else {
      setIsNormalClient(true);
      GlobalStore.isNormalClient = true;
      const clientPartialDetails_ao = JSON.parse(
        window.localStorage.getItem("clientPartialDetails_ao") || "{}"
      );
      clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
      window.localStorage.setItem(
        "clientPartialDetails_ao",
        JSON.stringify(clientPartialDetails_ao)
      );
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (objAccType === "RMINV") {
      setTimeout(() => {
        setSkipUrlBoolean(true);
        setPanFileUploadedLoader(false);
        setPanFileUploaded(true);
        setWillDoLater(true);
        setValidPan(false);
        setIsLoading(false);
        setRemovePanImg(false);
        setConsent(true);
        setTogPhoto(false);
        setPanNumberMatched(false);
        setDobChecked(true);
        setIsNormalClient(false);
        setErrorFoundInPanValidation(false);
        setPanUploaded(false);
        setPhotoErrorMsg("");
        setSeedingPopup(false);
        setCheckpanaaddharflag(true);
        setApplicationModeType("");
        setModalDisplayText("");
        setShowSubmitModal(false);
        setPanInvalidMsg("");
        setApplicationInitializedFlag(false);
        setSubmitFlag(false);
        setLiveLocationCheck({
          checkPhotoLiveness: false,
          checkLocation: false,
        });
        setStageBooleanFlags({
          isPersonalStage: false,
          isProfileStage: false,
        });
        setProdObj({
          ...prodObj,
          createdBy: UTM_CAMPAIGN,
          accountCategory: "2",
        });
      }, 500);
    }
  }, [objAccType]);

  const checkStatus = () => {
    // history.push(statusUrl.statusHome)
    navigate(statusUrl.statusHome)
  };

  return (
    <>
      {/* <Backdrop isCloseIcon isShow={showDigiRedirection} onClose={() => setShowDigiRedirection(false)}>
                <CheckDigilockerPopup onClose={setShowDigiRedirection} />
            </Backdrop> */}

      {/* need to change Indian to joint */}
      {entitySubType == "Joint" ? <PANInfoJoint /> :
        entitySubType == "Minor" ? <PANInfoMinor /> :
          entityType == "NONINDIVIDUAL" ? <PANInfoNonIndividual /> :
            <div className={"pan" + (isLoading ? " op05" : "")}>
              <div className="banner">
                <img className="bannerImg" src={regbanner} alt="banner" />
              </div>
              <div className="panHeading">
                <label>Let’s Get Started</label>
              </div>
              {!skipUrlBoolean && (
                <div className="panInfo">
                  <span>
                    Please upload a PAN Card to verify your details on Pan Card.
                  </span>
                </div>
              )}
              {GlobalStore.isOTCFlow && (
                <div className="panInfo">
                  <span>
                    Please provide your PAN card details below to proceed.
                  </span>
                </div>
              )}
              <div className="panForm">
                <form>
                  <fieldset disabled={isLoading}>
                    {cibilEmailFound ? (
                      <></>
                    ) : (
                      !skipUrlBoolean && (
                        <div className="row">
                          <div className={isLoading ? "not-allowed" : ""}>
                            <div className="uploadLayout">
                              <div className="mrt60 row">
                                <label className="photoSubHeading mrt10">
                                  Upload PAN Card
                                </label>
                                <div className="mrt20">
                                  <DocumentBrowse
                                    id="panCard"
                                    docObj={panObj}
                                    previewImageexternalClassName={
                                      "maxSizewithAnother"
                                    }
                                    onDocUploadComplete={onPanDocUploadComplete}
                                    isRemove={handleRemove}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}

                    {panFileUploadedLoader && (
                      <div className="row">
                        <Loader size={20} />
                      </div>
                    )}
                    {invalidPanFieldUploadedMsg != "" && (
                      <div className="errMsgBlck">
                        <ErrMsg>
                          <label>{invalidPanFieldUploadedMsg}</label>
                        </ErrMsg>
                      </div>
                    )}
                    {panFileUploaded &&
                      !panFileUploadedLoader &&
                      invalidPanFieldUploadedMsg == "" && (
                        <>
                          <fieldset disabled={errorFoundInPanValidation}>
                            <div className="row">
                              <label className="inptLbl">First Name</label>
                              <InputField
                                className="panInput"
                                disabled={
                                  objAccType === "RMINV"
                                    ? false
                                    : (
                                      prodObj?.createdBy !== null &&
                                      prodObj?.createdBy !== undefined &&
                                      prodObj?.createdBy !== 0 &&
                                      values?.firstName !== null &&
                                      values?.firstName !== undefined &&
                                      values?.firstName !== ""
                                    )
                                }
                                defaultValue={values?.firstName} //To be removed
                                onChange={(value) => onChange("firstName", value)}
                                required={true}
                                onBlur={(error: any, event) => {
                                  if (error.required) {
                                    setErrors({
                                      ...errors,
                                      firstName: errorMsg(errorCode.FE57),
                                    });
                                  } else if (
                                    !!values?.firstName &&
                                    (values.firstName as string).slice(-1) == " "
                                  ) {
                                    setErrors({
                                      ...errors,
                                      firstName: errorMsg(errorCode.FE55),
                                    });
                                  } else if (
                                    !!event?.target?.value &&
                                    event?.target?.value?.length > 0 &&
                                    !event?.target?.value?.replace(/\s/g, "").length
                                  ) {
                                    setErrors({
                                      ...errors,
                                      // firstname: error.required ? 'This field is required' : '',
                                      firstName: errorMsg(errorCode.FE55),
                                    });
                                  }
                                }}
                                type="text"
                                placeholder="Eg. Pranav"
                                //  pattern={pan}
                                errorText={errors.firstName}
                                maxLength={20}
                              // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                              />
                            </div>
                            <div className="row">
                              <label className="inptLbl">Middle Name</label>
                              <InputField
                                className="panInput"
                                defaultValue={values?.middleName}
                                disabled={
                                  objAccType === "RMINV"
                                    ? false
                                    : (
                                      prodObj?.createdBy !== null &&
                                      prodObj?.createdBy !== undefined &&
                                      prodObj?.createdBy !== 0 &&
                                      values?.middleName !== null &&
                                      values?.middleName !== undefined &&
                                      values?.middleName !== ""
                                    )
                                }

                                // defaultValue="CWLPA4946C" //To be removed
                                onChange={(value) => onChange("middleName", value)}
                                onBlur={(error: any, event) => {
                                  if (
                                    !!values?.middleName &&
                                    (values.middleName as string).slice(-1) == " "
                                  ) {
                                    setErrors({
                                      ...errors,
                                      middleName: errorMsg(errorCode.FE55),
                                    });
                                  } else if (
                                    !!event?.target?.value &&
                                    event?.target?.value?.length > 0 &&
                                    !event?.target?.value?.replace(/\s/g, "").length
                                  ) {
                                    setErrors({
                                      ...errors,
                                      // firstname: error.required ? 'This field is required' : '',
                                      middleName: errorMsg(errorCode.FE55),
                                    });
                                  }
                                }}
                                type="text"
                                placeholder="Eg. Prashant"
                                //  pattern={pan}
                                errorText={errors.middleName}
                                maxLength={20}
                              // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                              />
                            </div>
                            <div className="row">
                              <label className="inptLbl">Last Name</label>
                              <InputField
                                className="panInput"
                                defaultValue={values?.lastName}
                                // defaultValue="CWLPA4946C" //To be removed
                                disabled={
                                  objAccType === "RMINV"
                                    ? false
                                    : (
                                      prodObj?.createdBy !== null &&
                                      prodObj?.createdBy !== undefined &&
                                      prodObj?.createdBy !== 0 &&
                                      values?.lastName !== null &&
                                      values?.lastName !== undefined &&
                                      values?.lastName !== ""
                                    )
                                }
                                onChange={(value) => onChange("lastName", value)}
                                onBlur={(error, event) => {
                                  if (
                                    !!values?.lastName &&
                                    (values.lastName as string).slice(-1) == " "
                                  ) {
                                    setErrors({
                                      ...errors,
                                      lastName: errorMsg(errorCode.FE55),
                                    });
                                  } else if (
                                    !!event?.target?.value &&
                                    event?.target?.value?.length > 0 &&
                                    !event?.target?.value?.replace(/\s/g, "").length
                                  ) {
                                    setErrors({
                                      ...errors,
                                      // firstname: error.required ? 'This field is required' : '',
                                      lastName: errorMsg(errorCode.FE55),
                                    });
                                  }
                                }}
                                type="text"
                                placeholder="Eg. Joshi"
                                //  pattern={pan}
                                errorText={errors.lastName}
                                maxLength={40}
                              // suffix={validPan ? <i className="edel-icon-tick" /> : <></>}
                              />
                            </div>
                            {/* Pan Field start */}
                            <div className="row">
                              <label className="inptLbl">Enter PAN</label>
                              <InputField
                                className="panInput"
                                disabled={
                                  objAccType === "RMINV"
                                    ? false
                                    : (
                                      prodObj?.createdBy !== null &&
                                      prodObj?.createdBy !== undefined &&
                                      prodObj?.createdBy !== 0 &&
                                      values?.pan !== null &&
                                      values?.pan !== undefined &&
                                      values?.pan !== ""
                                    )
                                }
                                defaultValue={values?.pan}
                                // defaultValue="CWLPA4946C" //To be removed
                                onChange={(value) => {
                                  setPanInvalidMsg("");
                                  onChange("pan", value.toUpperCase());
                                }}
                                onBlur={(error) => onBlurPan(error)}
                                type="text"
                                placeholder="Eg. ABCDE1234F"
                                pattern={pan}
                                errorText={errors.pan}
                                maxLength={10}
                                suffix={
                                  validPan ? <i className="edel-icon-tick" /> : <></>
                                }
                              />
                            </div>
                            {/* Pan Field end */}

                            {/* DOB start */}
                            <div className="row">
                              <label className="inptLbl">Date of Birth</label>
                              <Calender
                                // defaultDate={new Date('December 24, 1996 00:00:00')} //To be removed
                                onDateSelect={(val) => onChange("dob", val)}
                                defaultDate={values?.dob ? values.dob : undefined}
                                placeholderText={"Select Date of Birth"}
                                maxDate={
                                  new Date(
                                    new Date().setFullYear(
                                      new Date().getFullYear() - 18
                                    )
                                  )
                                }
                                minDate={
                                  new Date(
                                    new Date().setFullYear(
                                      new Date().getFullYear() - 100
                                    )
                                  )
                                }
                                onBlur={onBlurDob}
                                disable={
                                  isLoading ||
                                  errorFoundInPanValidation ||
                                  getCheckedDobCondition()
                                }
                                isError={errors.dob ? true : false}
                              />
                            </div>

                            {errors.dob && (
                              <p className="help_text red">{errors.dob}</p>
                            )}
                            {/* DOB end */}
                          </fieldset>

                          {showSubmitModal && (
                            <div
                              style={{
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                                height: "160px",
                              }}
                            >
                              <Backdrop
                                width="width50"
                                isShow={modalDisplayText}
                                isCloseIcon={false}
                              >
                                <h3>Please Note!</h3>
                                <div className="explainInfo">
                                  {modalDisplayText ? (
                                    <div
                                      className="modaltext-Div"
                                      style={{ fontSize: "20px" }}
                                    >
                                      {modalDisplayText}
                                    </div>
                                  ) : (
                                    "Loading..."
                                  )}
                                </div>
                                <div className="mrt16  mrb16 sunBtn">
                                  <button
                                    className={`panpage-modalSubmit ${documentsInfo.totalDocsCount !==
                                      documentsInfo.uploadedDocsCount
                                      ? "disable"
                                      : ""
                                      }`}
                                    onClick={() => {
                                      if (applicationModeType === "isKRA") {
                                        // history.push(dashboardUrl.profile);
                                        navigate(dashboardUrl.profile)
                                      } else if (objAccType == "RMINV") {
                                        // history.push(dashboardUrl.personalIfo);
                                        navigate(dashboardUrl.personalIfo)
                                      } else if (applicationModeType === "isDigiLocker") {
                                        // history.push(containerUrl.dgLocker);
                                        navigate(containerUrl.dgLocker)
                                      }
                                    }}
                                    type="submit"
                                    disabled={
                                      objAccType === "RMINV"
                                        ? false
                                        : (
                                          documentsInfo.totalDocsCount !==
                                          documentsInfo.uploadedDocsCount
                                        )
                                    }
                                  >
                                    {documentsInfo.totalDocsCount !==
                                      documentsInfo.uploadedDocsCount
                                      ? "Please Wait"
                                      : "OK, Proceed"}
                                  </button>
                                </div>
                              </Backdrop>
                            </div>
                          )}
                          <div className="termList mrt41">
                            <Checkbox
                              checked={consent}
                              name="termone"
                              onChange={() => { }}
                            />
                            <label className="mrl13 linkLabel">
                              I authorize Nuvama to access my KYC records through C-KYC or KRA and validate my PAN details online. I confirm that the Date of Birth on my PAN will be considered as the valid DOB, even if it differs from the one on my Proof of Address (POA). I understand that the documents I upload will be used for reporting to KRA, and I assure that I will only upload original documents, avoiding screenshots, photocopies, or any forged documents.
                            </label>
                          </div>

                          {utmObj &&
                            Object.keys(utmObj).length > 0 &&
                            utmObj.utm_source &&
                            utmObj.utm_content &&
                            utmObj.utm_campaign && (
                              <div className="termList mrt41">
                                <label className="linkLabel assisted-label">
                                  You are being assisted
                                </label>
                              </div>
                            )}

                          {/* Error Msg Start*/}
                          {errCode && (
                            <div className="errMsgBlck">
                              <ErrMsg>
                                {typeof errCode === "number" ? (
                                  <>
                                    <label>We are facing some technical issue.</label>
                                    <label>
                                      Please try after sometime (error code:{errCode})
                                    </label>
                                  </>
                                ) : (
                                  <label>{errCode}</label>
                                )}
                              </ErrMsg>
                            </div>
                          )}
                          {/* Error Msg End*/}
                          {/* Pan Matching  Error Msg Start */}
                          {panInvalidMsg !== "" && panInvalidMsg?.length > 0 && (
                            <div className="errMsgBlck">
                              <ErrMsg>
                                <label>{panInvalidMsg}</label>
                              </ErrMsg>
                            </div>
                          )}
                          {/* Pan Matching  Error Msg End */}
                          <div className="row">
                            <Button
                              onClick={handleSubmit} //isNormalClient ? handleContinue :
                              btnName={isNormalClient ? "Continue" : "Proceed"}
                              // onClick={handleSubmit}
                              // btnName={"Proceed"}
                              disabled={
                                //                  Object.values(errors).some((error) => error) ||
                                //                    Object.values(values).some((value) => !value) ||
                                !(
                                  errors?.dob != null ||
                                  (errors?.dob != undefined &&
                                    errors.firstName != null) ||
                                  errors.firstName != undefined ||
                                  (errors.firstName !== "" && errors?.pan != null) ||
                                  errors?.pan != undefined ||
                                  errors?.pan !== ""
                                ) ||
                                values?.firstName == "" ||
                                values?.firstName == undefined ||
                                values.firstName == null ||
                                values?.pan == null ||
                                values?.pan == undefined ||
                                values?.pan == "" ||
                                (values?.firstName?.length == 0 &&
                                  values?.pan?.length == 0 &&
                                  (values?.dob === null ||
                                    values?.dob === undefined)) ||
                                values?.dob == null ||
                                values?.dob === undefined ||
                                (errCode == "" &&
                                  isNormalClient &&
                                  (!panNumberMatched || !dobChecked)) ||
                                !consent ||
                                liveLocationCheck.checkPhotoLiveness ||
                                liveLocationCheck.checkLocation ||
                                (skipUrlBoolean || cibilEmailFound
                                  ? false
                                  : !panOCR) ||
                                errCode
                              }
                              isLoading={isLoading}
                              type="submit"
                            />
                          </div>
                        </>
                      )}
                  </fieldset>
                </form>
              </div>
            </div>
      }
    </>
  );
};

export default PANInfo;
